import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const storedLanguage = localStorage.getItem("preferredLanguage");

const resources = {
  en: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: {
        userid: "Enter User Id",
        password: "Enter Password",
        role: "Select Role",
        VehicleTypeName11: "Vehicle Type",
        selectempname: "Select Employee Name",
        location: "Location",
        Elocation: "Enter Location",
        Juridiction: "Juridiction",
        AddNewPetrolPump: "Add New PetrolPump",
        cancel: "Cancel",
        EnterDesignationCode: "Enter Designation Code",
        EnterDesignation: "Enter Designation Name",
        EditEmployeeRegistration: "Edit Employee Registration",
        empStatus: "Select Status",
        EnterCode: "Enter Code",
        SelectZone: "Select Zone",
        DesignationCode1: "Designation Code",
        eScarp1: "Save Escrap Also",
        PetrolPumpName1: "PetrolPump Name",
        SelectStatus: "Select Status",
        Emaileventname1: "Email Event Name",
        Emaileventtype1: "Email Event Type",

        //employee

        Emailcampaigname1: "Email Campaign Name",
        Status1: "Status",
        Emailcampaign: "Create Email Campaign",
        toTime: "To Time",
        listGroups: "Select Group",
        listMembers: "Select Member",
        Emailcampaign1: "Email Campaign",
        EditEmailcampaign: "Edit Email Campaign",
        EnterEmployeeName: "Enter Employee Name",
        EnterEmployeeCode: "Enter Employee Code",
        EnterAdharNumber: "Enter Aadhar Number",
        SelectCity: "Select City",
        EnterPermanentAddress: "Enter Permanent Address",
        EnterPincode: "Enter Pincode",
        AttachedSignature: "Attached Signature",
        CreateEmployeeRegistration: "Create Employee Registration",
        EnterDrivingLicense: "Enter Driving License No.",
        SaveEscrapAlso: "Save Escrap Also",
        Designation1: "Select Designation",

        AddDesignation: "Create Designation",
        email12: "Email",
        isActive12: "Currently Active",
        Emailsettingmaster: "Email Settings",
        Type: "Select Type",
        isActive: "Status",
        AddEmaileventsetting: "Create Email Event Setting",
        EditEmaileventsetting: "Edit Email Event Setting",
        EmailtoDate: "To Date",
        EMAIL: "EMAIL",
        SMS: "SMS",
        templateId: "Enter Template Id",
        DepartmentName1: "Enter Department Name",
        wiretemp: "Wire Temp",
        Empdeptmaster: "Department Master",
        Departmentshortname1: "Enter Department Shortname",
        Headofdpt1: "Select Head Of Department",
        Editempdept: "Edit Department",
        EMAILGroup: "EMAIL Group",
        SMSGroup: "SMS Group",
        //campaign template
        CampaignTemplate: "Campaign Template",
        smsTemplateID: "Enter SMS Template ID",
        smsTemplateID1: "SMS Template ID",
        template: "Template",
        templateType: "Template Type",
        EditCampaignTemplate: "Edit Campaign Template",
        AddCampaignTemplate: "Create Campaign Template",

        //aniket sahu
        VehicleDetail: "Vehicle Detail",
        VehicleDetailAdd: "Create Vehicle Detail",
        VehicleDetailEdit: "Edit Vehicle Detail",
        EnterZone: "Select Zone",

        VehicleName: "Enter Vehicle Name",

        Code: "Enter Code",
        HsnCode: "Enter HsnCode",
        Category: "Select Category",
        VehicleType: "Select Vehicle Type",
        EnterUnit: "Select Unit",
        Tax: "Select Tax",

        // ModelNo:"Enter Model No",

        VehicleNe: "Enter Vehicle No",
        SimNo: "Enter Sim No",
        SimType: "Select Sim Type",
        SimCompanyName: "Enter Sim Company Name",
        SerialNo: "Enter Serial No",
        ChasisNo: "Enter Chasis No",

        PurchaseYear: "Enter Purchase Year",

        UnderControlOF: "Select Under Control Of",
        Department: "Enter Department",
        Designation: "Enter Designation",
        VehicleType: "Select Vehicle Type",
        BrandType: "Select Brand Type",
        FuelType: "Select Fuel Type",
        Weight: "Enter Weight (KG)",
        LitrePerHour: "Enter Litre Per Hour",
        KMperLitre: "Enter KM per Litre",
        DeviceNo: "Enter Device No",
        DeviceType: "Select Device Type",
        RFID1: "Enter RFID1",
        RFID2: "Enter RFID2",
        AllotedFuel: "Enter Alloted Fuel",
        EnterZone: "Select Zone",

        EnterDepartment: "Enter Department",

        //brand master
        BrandMaster: "Brand Master",
        BrandMasterAdd: "Create Brand Master",
        BrandMasterEdit: "Edit Brand Master ",
        BrandName: "Enter Brand Name",
        BrandCode: "Enter Brand Code",
        ShortName: "Enter Short Name",

        BrandNames: "Brand Name",
        BrandCodes: "Brand Code",
        BrandShortNames: "Short Name",

        //fuel Type
        FuelTypes: "Fuel Type",
        FuelTypeAdd: "Create Fuel Type",
        FuelTypeEdit: "Edit Fuel Type ",
        FuelTypeName: "Enter Fuel Type Name",
        FuelCode: "Enter Fuel Code",
        FuelShortName: "Enter Fuel ShortName",
        FuelTypeNames: "Fuel Type Name",
        FuelCodes: "Fuel Code",
        FuelShortNames: "Fuel ShortName",

        //Vehicletype
        VehicleTypes: "Vehicle Type",
        VehicleTypeAdd: "Create  Vehicle Type",
        VehicleTypeEdit: "Edit Vehicle Type",
        VehicleTypeName1: "Enter Vehicle Type Name",
        VehicleCode: "Enter Vehicle Code",
        VehicleShortName: "Enter Vehicle ShortName",
        VehicleTypeNames: "Vehicle Type Name",
        VehicleCodes: "Vehicle Code",
        VehicleShortNames: "Vehicle ShortName",

        //vehicletypeIfo
        VehicleTypeInfo: "Vehicle Type Info",
        VehicleTypeInfoAdd: "Create Vehicle Type Info",
        VehicleTypeInfoEdit: "Edit Vehicle Type Info",
        PetrolPumpName: "Enter PetrolPump Name",
        EffectiveDate: "Enter Effective Date",

        VehicleTypeName: "Select Vehicle Type",

        Shift1: "Enter Shift-1(Fuel(Lt))",
        Shift2: "Enter Shift-2(Fuel(Lt))",
        PetrolPump: "Select PetrolPump",
        FirstSessionFuelLts: "First Session Fuel(Lts)",
        SecondSessionFuelLts: "Second Session Fuel(Lts)",
        PetrolPumps: "PetrolPump",
        EffectiveDates: "Effective Date",

        //VehicleAudit
        NewInstallation: "New  Installation",
        Updation: "Updation",

        replacementInfo: "replacement Info",

        Sim: "Sim",
        Device: "Device",
        Both: "Both",

        VehicleAudit: "Vehicle Audit",
        VehicleAuditAdd: "Create Vehicle Audit",
        VehicleAuditEdit: "Edit Vehicle Audit",

        VehicleNos1: "Select Vehicle No",
        DriverName: "Enter Driver Name",
        DriverMobileNo: "Enter Driver Mobile No",
        ServiceEngg: "Enter Service Engineer",
        SimNo: "Enter SimNo",
        OldSimNo: "Enter Old SimNo",
        DeviceNo: "Enter Device No",
        OldDeviceNo: "Enter Old DeviceNo",
        ProblemType: "Select Problem Type",
        Remark1: "Enter Remark",
        Image: "Upload Image",
        VehicleNo12: "Vehicle No",

        VehicleNos1: "Select Vehicle No.",
        DriverName: "Enter Driver Name",
        DriverMobileNo: "Enter Driver Mobile No.",
        ServiceEngg: "Enter Service Engineer",
        SimNo: "Enter Sim No.",
        OldSimNo: "Enter Old Sim No.",
        DeviceNo: "Enter Device No.",
        OldDeviceNo: "Enter Old Device No.",
        ProblemType: "Select Problem Type",
        Remark1: "Enter Remark",
        Image: "Upload Image",
        VehicleNo12: "Vehicle No.",

        ServiceEng1: "Service Engineer",

        //FuelBalCorrection
        FuelBalCorrection: "Fuel Bal Correction",
        FuelBalCorrectionAdd: "Create Fuel Bal Correction",
        FuelBalCorrectionEdit: "Edit Fuel Bal Correction",
        VehicleNo: "Select Vehicle No",
        forallvehicle: "for All Vehicle",
        devid: "Device No.",
        trackDate: "Track Date",
        opBalanceExist: "OP Balance",
        opBalanceCorr: "Correct Balance",

        //group

        name: "Name",
        name1: "Enter Name",
        description1: "Enter Description",
        description: "Description",
        Creategroupmaster: "Create Group",
        Groupmaster: "Group",
        Editgroupmaster: "Edit Group",

        //email compaign
        Emailcampaign: "Create Email Campaign",
        toTime: "To Time",
        listGroups: "Select Group",
        listMembers: "Select Member",

        //area ward
        AreaName: "Area Name",
        WardNumber: "Ward Number",
        Zone: "Zone",
        AreaWard: "Area/Ward",
        AreaWardEdit: "Edit Area/Ward",
        EnterAreaName: "Enter Area Name",
        EnterWardNumber: "Enter Ward Number",
        EnterZone: "Enter Zone",

        //BinKudaghar
        BinKudaghar: "Bin/Kudaghar",
        BinSrNo: "Srno",
        BinName: "Bin Name",
        BinCode: "Bin Code",
        BinRFID: "RFID",
        BinArea: "Area",
        BinWard: "Ward",
        BinZone: "Zone",
        BinLatitude: "Latitude",
        BinLongitude: "Longitude",
        AddBin: "Add Bin",
        EnterBinAreaName: "Enter Area Name",
        EnterBinWardNumber: "Enter Ward Number",
        EnterBinZone: "Enter Zone",
        EnterBinName: "Enter Bin Name",
        EnterBinCode: "Enter Bin Code",
        EnterBinRFID: "Enter Bin RFID",
        EnterBinDesc: "Enter Bin Description",
        EditBinData: "Edit Bin Data",

        //HandheldInfo
        HandheldInfo: "Handheld Info",
        HandheldDeviceName: "Device Name",
        HandheldDeviceCode: "Device Code",
        EnterDeviceName: "Enter Device Name",
        EnterDeviceCode: "Enter Device Code",
        AddHandheldInfo: "Add Handheld Info",
        EditHandheldInfo: "Edit Handheld Info",

        //RouteDetail
        RouteDetail: "Route Detail",
        RouteName: "Route Name",
        RouteDesc: "Route Description",
        RouteDate: "Route Date",
        AddRouteDetail: "Add Route Detail",
        EditRouteDetail: "Edit Route Detail",
        EnterRouteName: "Enter Route Name",
        EnterRouteDesc: "Enter Route Description",
        EnterRouteDate: "Enter Route Date",

        //RosterPlan
        RosterPlan: "Roster Plan",
        RosterNumber: "Roster Number",
        RosterDate: "Roster Date",
        RosterFromDate: "From Date",
        RosterToDate: "To Date",
        AddRosterPlan: "Add Roster Plan",
        EditRosterPlan: "Edit Roster Plan",
        EnterRosterNumber: "Enter Roster Number",
        EnterRosterDate: "Enter Roster Date",
        EnterRosterFromDate: "Enter From Date",
        EnterRosterToDate: "Enter To Date",

        //BinKudagharPriority
        BinPriority: "Bin/Kudaghar Priority",
        BinPriorityRouteName: "Route Name",
        BinPriorityDesc: "Description",
        BinPriorityDate: "Route Date",
        EnterBinRouteName: "Enter Route Name",
        EnterBinRouteDate: "Enter Route Date",
        EnterBinDesc: "Enter Description",
        EnterBinTime: "Enter Time",
        EnterBinTimeInterval: "Enter Time Interval",
        AddBinPriority: "Add Bin/Kudaghar Priority",
        EditBinPriority: "Edit Bin/Kudaghar Priority",

        //himanshu
        groupadd: "Create Group",
        SelectEmployeeName: "Select Employee Name",
        ParentName: "Parent Name",
        EmployeeMaster: "Employee Master",
        EmpName: "Employee Name",
        EmpCode: "Employee Code",
        EmpStatus: "Employee Status",
        SelectState: "Select State",
        SelectCountry: "Select Country",
        SelectDistrict: "Select District",
        reqEmpName: "Employee name Is Require",
        reqEmpCode: "Employee Code is Require",
        reqFatherName: "Father Name Is Require",
        reqMobNo: "Mobile Number Is Require",
        reqPanNo: "Pan Number Is Require",
        reqJoiningDate: "Joining Date Is Require",
        reqDesignation: "Designation Is Require",
        reqDepartment: "Department Is Require",
        reqPerAddress: "Permanent Address Is Require",
        reqPinCode: "Pin Code Is Require",
        reqAdharNo: "Adhar Number Is Require",
        reqEmail: "Email Is Require",
        reqEmpdob: "Employee DOB Is Required",
        CreateEmployeeReg: "Create Employee Registration",
        EditEmployeeReg: "Edit Employee Registration",
        EnterEmpName: "Enter Employee Name",
        EnterEmpCode: "Enter Employee Code",
        EnterFatherName: "Enter Father Name",
        EnterSpauseName: "Enter Spause Name",
        EnterMotherName: "Enter Mother Name",
        EnterMobileNumber: "Enter Mobile Number",
        EnterEmail: "Enter Email",
        EnterPanNo: "Enter Pan Number",
        EnterAdharNo: "Enter Adhar Number",
        EnterDOB: "Enter Date Of Birth",
        EnterJoiningDate: "Enter Joining Date",
        EnterRetirementDate: "Enter Retirement Date",
        EnterLocalAddress: "Enter Local Address",
        EnterPerAddress: "Enter Permanent Address",
        EnterPinCode: "Enter Pin Code",
        AttachedImage: "Attached Image",
        DocManagerReport: "Doc Manager Report",
        SelectSubSubject: " Select Sub Subject",
        SubSubjectName: "Sub Subject Name",
        DivisionName: "Division Name",
        Remark: "Remark",
        SessionYear: "Session Year",
        InActive: "InActive",
        Active: "Active",
        TotalDoc: "Total Document",
        TotalType: "Total Type",
        TotalIndexFile: "Total Index File",
        TotalSplitFile: "Total Split File",
        Zone: "Zone",
        LineChart: "Line Chart",
        Department: "Department",
        AcademicDepartment: "Academic Department",
        DocumentManagementSystem: "Document Management System",
        DocMng: "Document Manager",
        PartNo: "Part Number",
        PeriodFileNo: "Period File Number",
        AuthonticatedPerson: "Authonticated Person",
        FileDate: "File Date",
        SubjectId: "Subject ID",
        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        DesignationMaster: "Designation Master",

        Date: "Date",
        Type: "Type",
        Time: "Time",
        EmailSystem: "Email System",
        AddEmailsystem: "Create Email System",
        Editemailsystem: "Edit Email System",
        Emaildescription: "Email Description",
        Smsgroup: "Sms group",
        Emailgroup: "Email group",
        Statusactive: "Select Status",
        EmailSetting: "Email Settings ",
        Emailtype: "Type",
        //

        Emailcampaigname: "Enter Campaign Name",
        Emailfromdate: "From Date",
        Emailtodate: "To Date",
        Emailcampgiandate: "Campaign Date",
        Template: "Select Template",
        Type: "Type",
        Totime: "To Time",
        execute: "Save & Execute",
        Emaileventsetting: "Email Event Setting",
        Emaileventtype: "Select Event Type",
        Emaileventname: "Enter Event Name",
        message: "Enter Message",
        // employee
        Employeeinfo: "Employee Info",
        Empname: "Employee Name",
        Employee: "Employee",
        Code: "Code",
        Mobileno: "Mobile No",
        Address: "Address",
        Department: "Department",
        DepartmentName: "Department Name",
        Departmentshortname: "Department Short Name",
        Headofdpt: "Head of Department",

        Designationmaster: "Designation Master",
        DesignationName: "Designation Name",
        DesignationCode: "Designation Code",
        Addesignation: "Create Designation",
        Designation: "Designation",
        DesignationCode: "Designation Code",
        Name: "Name",
        Fathername: "Father Name",
        Mothername: "Mother Name",
        Gender: "Gender",
        DOB: "DOB",
        MobileNo: "MobileNo",
        Email: "Email",
        Panno: "Pan No",
        Aadharno: "Aadhar No",
        joiningdate: "JoiningDate",
        RetirementDate: "RetirementDate",
        Maindetails: "Main Details",
        Signature: "Signature",
        Image: "Image",
        BasicInformation: "Basic Information",
        DrivingLicence: "Driving Licence",
        Department: "Department",
        paddress: "Permanent Address",
        laddress: "Local Address",
        Country: "country",
        State: "State",
        City: "City",
        PinCode: "Pincode",
        editDesignation: "Edit Designation",
        AddDepartment: "Create Department",
        EditDepartment: "Edit Department",

        VehicleNos: "Vehicle No",
        UnderControlOFs: "Under Control OF",
        Departments: "Department",
        Designations: "Designation",

        zoneMaster: "Zone Master",
        add: "ADD",
        Add: "ADD",
        print: "PRINT",
        Print: "Print",
        Active: "Active",
        InActive: "InActive",
        Action: "Action",
        SrNo: "Sr No.",
        zoneName: "Zone Name",
        zoneCode: "Zone Code",
        Status: "Status",
        search: "Search",
        save: "Save",
        reset: "Reset",
        createZoneMaster: "Create Zone Master",
        editZoneMaster: "Edit Zone Master",
        enterZoneName: "Enter Zone Name",
        enterZoneCode: "Enter Zone Code",
        req: "Enter Zone Name required",
        update: "Update",
        wardMaster: "Ward Master",
        wardName: "Ward Name",
        wardCode: "Ward code",
        createWardMaster: "Create Ward Master",
        editWardMaster: "Edit Ward Master",
        enterWardName: "Enter Ward Name",
        enterWardCode: "Enter Ward Code",
        req1: "Enter Ward Name required",
        SelectZoneName: "Select Zone Name ",
        reqSelectZoneName: "Select Zone Name is required",
        CategoryMaster: "Category Master",
        CategoryName: "Category Name",
        EnterCategoryName: "Enter Category Name",
        CreateCategoryMaster: "Create Category Master",
        reqCategory: "Enter Category Name required",
        EditCategoryMaster: "Edit Category Master",
        SubCategoryMaster: "Sub Category Master",
        SubCategoryName: "Sub Category Name",
        RemarkName: "Remark",
        CreateSubCategoryMaster: "Create Sub Category Master",
        EnterSubCategoryName: "Enter Sub Category Name",
        EnterCategoryRemark: "Enter Category Remark",
        reqSelectCategory: "Select Category Required",
        reqEnterSubCategory: "Sub Category Required",
        SelectCategory: "Select Category ",
        EditSubCategoryMaster: "Edit Sub Category Master",
        AdvertiseLocationMaster: "Advertisement Location Master",
        AdvertiseArea: "Advertise Area",
        NearestLocation: "Nearest Location",
        NoOfSites: "No Of Sites",
        latitute: "Latitute",
        longitude: "Longitude",
        CreateAdvertiseLocationMaster: "Create Advertisement Location Master",
        EnterLandmark: "Enter Landmark",
        AttachAdvertiseLocationImage: "Attach Advertisement Location Image",
        selectZone: "Select Zone",
        EditAdvertiseLocationMaster: "Edit Advertisement Location Master",
        FinancialCalendarMaster: "Financial Calendar Master",
        FinancialYear: "Financial Year",
        FromDate: "From Date",
        Todate: "To date",
        CreateFinancialCalendarMaster: "Create Financial Calendar Master",
        ReqEnterFinancialYear: "*Required Enter Financial Year",
        ReqEnterFromDate: "*Required Enter From Date",
        RequiredEnterToDate: "*Required Enter To Date",
        EditFinancialCalendarMaster: "Edit Financial Calendar Master",
        AdvertisementTypeMaster: "Advertisement Type Master",
        AdvertisementName: "Adv. Name",
        rateIsFixed: "Rate Fixed",
        rateType: "Rate Type",
        DayWise: "Day Wise",
        MonthWise: "Month Wise",
        YearWise: "Year Wise",
        createAdvertisementTypeMaster: "Create Advertisement Type Master",
        enterAdvertisementTypeName: "Enter Advertisement Type Name",
        EditAdvertisementTypeMaster: "Edit Advertisement Type Master",
        AdvertisementSubTypeMaster: "Advertisement Sub Type Master",
        SubAdvertisementName: "Sub Adv. Name",
        Description: "Description",
        MaxLength: "Length",
        MaxWidth: "Width",
        MaxHeight: "Height",
        AreaSquareMeter: "Area Sq Mtrs",
        ratePerSqMtr: "Rate/SqMtr",
        Amount: "Amount",
        Premium: "Premium",
        BasePrice: "Base Price",
        CreateSubAdvertisementTypeMaster:
          "Create Sub Advertisement Type Master",
        reqAdvertismentTypeName:
          "Enter Advertisement Type Name should be required",
        EnterSubAdvertisementName: "Enter Sub Advertisement Name",
        EnterDescription: "Enter Description",
        EnterMaxLength: "Enter Max Length (in feet)",
        EnterMaxWidth: "Enter Max Width (in feet)",
        EnterMaxHeight: "Enter Max Height (in feet)",
        EnterAreaSquareMeter: "Enter Area Square Meter",
        EnterRatePerSquareMeter: "Enter Rate Per Square Meter",
        EnterAmount: "Enter Amount",
        EnterPremium: "Enter Premium",
        EnterBasePrice: "Enter Base Price",
        EditSubAdvertisementTypeMaster: "Edit Sub Advertisement Type Master",
        TaxMaster: "Tax Master",
        TaxName: "Tax Name",
        TaxPercentage: "Tax Percentage",
        EffectiveDate: "Effective Date",
        CreateTaxMaster: "Create Tax Master",
        EnterTaxName: "Enter Tax Name",
        EnterTaxPercentage: "Enter Tax Percentage",
        EnterEffectiveDate: "Enter Effective Date",
        reqTaxPercentage: "Tax Percentage must be a positive number",
        reqTaxName: "Tax Name is required",
        reqEffectiveDate: "Effective Date is required",
        EditTaxMaster: "Edit Tax Master",
        MenuMaster: "Menu Master",
        ParentName: "Parent Name",
        MenuName: "Menu Name",
        PageURL: "Page URL",
        Icon: "Icon",
        CreateMenuMaster: "Create Menu Master",
        EnterMenuName: "Enter Menu Name",
        EnterPageURL: "Enter Page URL ",
        EnterIcon: "Enter Icon ",
        selectParentMenuName: "Select Parent Menu Name ",
        reqMenuName: "Menu Name is required",
        EditMenuMaster: "Edit Menu Master",
        RoleMaster: "Role Master",
        RoleName: "Role Name",
        UserPermissionMaster: "User Permission Master",
        UserName: "User Name",
        CountryMaster: "Country Master",
        CountryName: "Country Name",
        CountryCode: "Country Code",
        Nationality: "Nationality",
        CreateCountryName: "Create Country Name",
        EnterCountryName: "Enter Country Name",
        EnterCountryCode: "Enter Country Code",
        EnterNationality: "Enter Nationality",
        EditCountryMaster: "Edit Country Master",
        StateMaster: "State Master",
        StateName: "State Name",
        StateCode: "State Code",
        CreateStateMaster: "Create State Master",
        EnterStateName: "Enter State Name",
        EnterStateCode: "Enter State Code",
        SelectCountryName: "Select Country Name",
        EditStateMaster: "Edit State Master",
        DistrictMaster: "District Master",
        DistrictName: "District Name",
        DistrictCode: "District Code",
        CreateDistrictMaster: "Create District Master",
        EnterDistrictName: "Enter District Name",
        EnterDistrictCode: "Enter District Code",
        SelectDistrictName: "Select District Name",
        EditDistrictMaster: "Edit District Master",
        GenderMaster: "Gender Master",
        GenderName: "Gender Name",
        GenderCode: "Gender Code",
        CreateGenderMaster: "Create Gender Master",
        reqGenderName: "Gender Name  is required",
        EnterGenderName: "Enter Gender Name",
        EnterGenderCode: "Enter Gender Code",
        SelectGenderName: "Select Gender Name",
        EditGenderMaster: "Edit Gender Master",

        UserManegment: "User Management",
        FirstName: "First Name",
        LoginName: "Login Name",
        MobileNo: "Mobile No",
        Email: "Email",
        DateOfBirth: "Date Of Birth",
        Role: "Role",
        SelectGender: "Select Gender",
        SelectRole: "Select Role",
        SelectUserType: "Select UserType",
        CreateUserManegment: "Create User Management",
        reqFirstName: "First Name Required",
        reqMiddleName: "Middle Name Required",
        reqLastName: "Last Name Required",
        reqloginID: "login ID Required",
        reqPassword: "Password Required",
        reqMobileNumber: "Mobile Number Required",
        reqEmailID: "Email ID Required",
        reqDateofBirth: "Date of Birth Required",
        reqGender: "Gender Required",
        reqUserType: "User Type Required",
        reqRole: "Role Required",
        EnterFirstName: "Enter First Name",
        EnterMiddleName: "Enter Middle Name",
        EnterLastName: "Enter Last Name",
        EnterLoginName: "Enter Login Name",
        EnterPassword: "Enter Password",
        EnterUserCode: "Enter User Code",
        EnterMobileNo: "Enter Mobile No",
        EnterEmailId: "Enter Email-Id",
        EnterDateOfBirth: "Enter Date Of Birth",
        EditUserManegment: "Edit User Management",
        UserTypeMaster: "User Type Master",
        EnterUserType: "Enter User Type",
        UserType: "User Type",
        InvalidUserType: "Invalid User Type",
        enterRoleName: "Enter Role Name",
        reqRoleName: "Role Name Required",
        reqcountryName: "Select Country Name Required",
        reqstateName: "State Name Required",
        reqdistrictName: "District Name Required",
        SelectStateName: "Select State Name",
        SelectWard: "Select Ward",
        reqAreaName: "Advertise Area is required",
        reqNoOfSites: "No Of Sites is  required",
        reqImg: "Advertise image is required",
        reqAdvertisementTypeID: "Select Advertisement Type Required",
        reqMaxLength: "Length is  Required",
        reqMaxWidth: "Width  is Required",
        reqMaxHeight: "Height is  Required",
        reqRatePerSqMtr: "Rate Square Meter is  Required",
        reqPremium: "Premium Amount is  Required",
        RegisterAgency: "Register Agency / Vendor",
        RenewRegisterAgency: "Renew Register Agency / Vendor",
        ApplyDate: "Apply Date",
        NameOfAgency: "Agency Name",
        ContactNo: "Contact No",
        Address: "Address",
        PANNo: "PAN No",
        AadhaarNo: "Aadhaar No",
        GSTNo: "GST No",
        ApplicationFee: "Application Fee",
        SelectCompanyCategory: "Select Company Category",
        reqAadharNumber: "Aadhar Number Required",
        reqBalanceSheet: "Balance Sheet Required",
        reqAddress: "Address Required",
        reqState: "State Required",
        reqEmail: "Email Required",
        reqDistrict: "District Required",
        reqCompanyCategory: "Company Category Required",
        reqPaymentMode: "Payment Mode Required",
        reqTransactionNumber: "Transaction Number Required",
        DateOfApply: "Date Of Apply",
        EnterRegistrationNo: "Enter Registration No",
        EnterName: "Enter Name",
        EnterContactNo: "Enter Contact No",
        EnterEmailID: "Enter Email ID",
        EnterPANNo: "Enter PAN No",
        EnterGSTNo: "Enter GST No",
        EnterAadharNo: "Enter Aadhar No",
        EnterAddress: "Enter Address",
        EnterApplicationFees: "Enter Application Fees",
        EnterRegistrationFees: "Enter Registration Fees",
        reqEnterRegistrationFees: "Registration Fees Required",
        EnterAgencyName: "Enter Agency name",
        EnterDINNumber: "Enter D.I.N. Number",
        DINNumber: "D. I. N. Number",
        EmailID: "Email ID",

        Yes: "Yes",
        No: "No",

        Preview: "Preview",
        Attach: "Attach",

        Back: "Back",
        Submit: "Submit",
        Next: "Next",
        BasicDetails: "Basic Details",
        AgencyDetails: "Agency Details",
        TermsAndConditions: "Terms and Conditions",
        DocUpload: "Doc Upload",
        reqApproval: "Approval Required",
        ApprovalRegistration: "Approval for Vendor/Agency Registration",
        AlertBeforeApproval:
          "Are you sure? Has all documents been verified before approval",
        EditAgency: "EDIT AGENCY / VENDOR",
        DefaultFinancialYear: "Default Financial Year",
        IsRateFixed: "Is Rate Fixed",
        EnterRateType: "Enter Rate Type",
        RateType: "Rate Type",
        rate: "Rate",
        SelectRateType: "Select Rate Type",
        YouCannotChangeData: "You can not change this data",
        NoDataAvailable: "No data available",
        PaymentDetails: "Payment Details",

        reqName: "Name Required",
        reqAadhaar: "Aadhaar number is required",
        reqAadhaarexactly: "Aadhaar number must be exactly 12 digits",
        reqMobile: "Mobile Number Required",
        reqRegistrationPayment: "Registration Payment Mode Required",
        reqPanNumber: "Pan Number is required",
        reqGSTINnumber: "GSTIN Number is required",
        reqApplyDate: "Apply Date is required",
        reqAlert:
          "Please fill all required fields (Name of Agency, DIN Number, Email ID, and Mobile Number) before adding to the table.",
        validMobile: "is-valid-mobile",
        InvalidMobile: "Invalid mobile number format",
        validEmail: "is-valid-email",
        InvalidEmail: "Invalid email format",
        EnterApplicationTransaction: "Enter Application Transaction Nos.",
        EnterChequeNo: "Enter Application Cheque Nos.",
        EnterCashReceipt: "Enter Application Receipt Nos.",
        EnterNEFT: "Enter Application NEFT Nos.",
        EnterRTGS: "Enter Application RTGS Nos.",
        SelectRegisPaymentMode: "--Select--",
        EnterRegTransaction: "Enter Registration Transaction Nos.",
        EnterRegChequeNo: "Enter Registration Cheque Nos.",
        EnterRegCashReceipt: "Enter Registration Receipt Nos.",
        EnterRegNEFT: "Enter Registration NEFT Nos.",
        EnterRegRTGS: "Enter Registration RTGS Nos.",
        ApplicationFees: "Application Fees",
        SelectRegistrationPaymentMode: "Select Reg. Payment Mode",
        EnterRegistrationTransactionNumber:
          "Enter Registration Transaction Number",
        RegistrationFees: "Reg. Fees",
        Name: "Name",
        reqFirst: "First Name Required",
        reqLast: "Last Name Required",
        reqLogin: "login ID Required",
        reqDate: "Date of Birth Required",
        reqUser: "User Type Required",
        HearingInformation: "Hearing Information",
        action: "action",
        settled: "settled",
        nextHear: "nextHearing",
        repBy: "reported by",
        remDate: "Remainder Date",
        decision: "decision",
        remark: "remark",
        case_status: "case_status",
        fill_date: "fill_date",
        update_status_date: "update_status_date",
        reqCaseNo: "Case No is required",
        reqAction: "Action is required",
        reqNextHear: "Next Hearing  is required",
        reqRepBy: "reported by is required",
        reqRemDate: "Reminder Date is required",
        reqDecision: "Decision is required",
        reqRemark: "Remark is required",
        reqCaseStatus: "Case status is required",
        reqFillDate: "Fill date is required",
        reqUpdateStatusDate: "Update status date is required",
        caseNo: "caseNo",
        CreateHearingInformation: " Create HearingInformation",
        EnterCaseNo: "Enter Case Number",
        EnterAction: "Enter Action",
        EnterRepBy: "Enter Report By",
        EnterDecision: "Enter Decision",
        EnterRemark: "Enter Remark",
        EnterCaseStatus: "Enter case status",
        EnterFillDate: "Enter Fill Date",
        EnterUpdateDate: "Enter Update Date",
        EnterRemDate: "Enter Reminder Date",
        EnterNextHear: "Enter Next Hearing",
        EditHearingInformation: "Edit  Case Hearing Information",
        DefaultYear: "Default Year",
        CaseStageMaster: "Case Stage Master",
        EnterCaseStage: "Enter Case Stage",
        CaseStage: "Case Stage",
        CaseTypeMaster: "Case Type Master",
        EnterCaseType: "Enter Case Type",
        CaseType: "Case Type",
        CaseCategoryMaster: "Case Category Master",
        EnterCaseCategory: "Enter Case Category ",
        CaseCategory: "Case Category ",
        courtTypeMaster: "Court Type Master",
        EnterCourtType: "Enter Court Type",
        CourtType: "Court Type",
        CourtNameMaster: "Court Name Master",
        EnterCourtName: "Enter Court Name",
        CourtName: "Court Name",
        CrimeNatureMaster: "Crime Nature Master",
        EnterCrimeNature: "Enter Crime Nature",
        CrimeNature: "Crime Nature",
        PetitionerPersonalInformation: "Petitioner Personal Information",
        WritNo: " Writ No",
        Casecategory: "Case Category ",
        CounselForPetitioner: "Counsel for Petitioner",
        OICEmail: "officer Incharge Email",
        OICMobile: "officer Incharge Mobile",
        PetitionerName: "Petitioner name",
        CaseDate: "Case Date",
        MobileNumber: "Mobile Number",
        CaseStatus: "Case Status",
        reqCourtType: "Court Type Required",
        reqCaseCategory: "Case Category Required",
        reqCaseType: "Case Type Required",
        reqCourtName: "Court Name Required",
        reqCrimeNature: "Crime Nature Required",
        reqCaseStage: "Case Stage Required",
        SelectCaseType: "Select Case Type",
        SelectCaseCategory: "Select Case Category",
        createPetitioner: " Create Petitioner Personal Information",
        EnterWritNo: "Enter Writ no",
        EnterCounselForPetitioner: "Enter Counsel for Petitioner",
        EnterEmail: "Enter Email",

        deptMaster: "Department Master",
        deptName: "Dept. Name",
        deptCode: "Dept. Code",
        createdeptmaster: " Create Department Master",
        editdeptmaster: "Edit Department Master",
        enterdeptName: "Enter Department Name",
        enterdeptCode: "Enter Department Code",
        reqdept_name: "Department Name Required",
        desName: "Designation Master",
        Designationmastermain: "Designation Master",
        editDesignation: "Edit Designation Master",
        AddDesignation: "Create Designation Master",

        createddesigMAster: "Create Designation Master",
        reqdesignname: "Designation Name Required,",
        enterDesName: "Enter Designation Name",
        entershortCode: " Enter Designation Code",
        selectDet: "Select Department",
        reqdept_id: "Select Department Required",
        editdesMaster: "Edit Designation Master",
        AttachImg: "Attach Transaction Receipt",
        SelectDepartment: "Select Department",
        SelectDesignation: "Select Designation",

        FileClass: "File Class",
        classDescription: "Class Description",
        shortName: "Short Name",
        weedingOutAuthority: "Weeding Out Authority",
        CreateclassDescription: "Create Class Description",
        EnterShortName: "Enter Short Name",
        EnterClassDescription: "Enter Class Description",
        EnterWeedingOutAuthority: "Enter Weeding Authority ",
        CreateFileClass: "Create File Class",
        EditFileClass: "Edit File Class",
        FileGroupName: "File Group Name",
        EnterFileGroupName: "Enter File Group Name",
        FileGroup: "File Group",
        FileSubject: "File Subject",
        EnterFileSubjectName: " Enter File Subject Name",
        FileSubjectName: "File Subject Name",
        // ShortName: "Short Name",
        FileType: "File Type",
        EnterFileTypeName: "Enter File Type Name",
        FileTypeName: "File Type Name ",
        SelectFileGroup: "Select File Group",
        SelectFileCategory: "Select File Category",
        SelectFileType: "Select File Type",
        SelectFileNo: "Select File Number",
        SelectFileClass: " Select File Class",
        SelectFileSubject: "Select File Subject",
        ReceiptStatus: "Receipt Status",
        RecName: "Receipt Name",
        EnterRecName: "Enter Receipt Name",
        ReceiptType: "Receipt Type",
        ReceiptName: "Receipt Name",
        EnterReceiptName: "Enter Receipt Name",
        RecStatus: "Receipt Status",
        EnterRecStatus: "Enter Receipt Status",
        reqRecStatus: "Require Receipt Status ",
        Location: "Location",
        LocationName: "Location Name",
        EnterLocationName: "Enter Location Name",
        LocationShortName: " Location Short Name",
        EnterLocationShortName: "Enter Location Short Name",
        senderID: "Sender ID",
        receiverID: " Recever ID",
        currentLocation: " Current Location",
        EnterSignatureUpload: "Attach Signature",
        EnterLocationObject: "Enter Location Object",
        EnterAbbreviation: "Enter Abbreviation",
        Abbreviation: "Abbreviation",
        LocationObject: "Location Object",
        reqLocationObject: "Require Location Object ",
        reqFileGroupName: "Require File Group Name",
        reqFileSubjectName: "Require File Subject Name",
        reqFileTypeName: "Require File Type Name",
        reqReceiptName: "Require Receipt Name",
        EnterDocUpload: "Attach Document",
        EnterDocSubType: "Doc Subject Type",
        EnterSubDocAbbreviation: "Doc Subject Abbreviation",
        SelectDoctype: "Select Doc Type",
        SelectFileName: "Select file Name",
        SelectSubject: "Select Subject",
        EnterSubFtype: "subject file type",
        SelectDivision: "Select Division",
        EnterCountryShortName: " Enter Country Short Name",
        EnterStateShortName: "Enter State Short Name",
        EnterdisplayNo: "Enter Display Number",
        SelectDocType: "Select Doc Type",
        enterDesCode: "Enter Designation Code",
        DesignationName: "Designation Name",
        DesignationCode: "Designation Code",
        DocType: "Document Type",
        DocSubType: "Document Sub Type",
        CreateDocType: "Create Doc Type",
        EditDocType: "Edit Doc Type",
        EnterDocType: "Enter Doc Type",
        EntryDate: "Entry Date",
        EnterDocName: "Enter Doc Name",
        DocSubject: "Doc Subject",
        Subject: "Subject",
        DocSubSubject: "Doc Sub Subject",
        SubSubject: "Sub Subject",
        FileNo: "File Number",
        Synopsis: "Synopsis",
        FileDef: "File Definition",
        DocumentEntry: "Document Entry",
        DocumentEntryAdd: "Add Document Entry ",
        reqFileNo: "File No Is Require",
        EnterFileNo: "Enter File Number",
        EnterSynopsis: "Enter Synopsis",
        EnterPartNo: "Enter Part Number",
        EnterPeriodFileUpto: "Enter Period File Upto",
        EnterSubject: "Enter Subject",
        EnterFileDef: "Enter File Definition",
        EnterComplete: "Enter Complete",
        EnterAuthenticatePerson: "Enter Authenticated Person",
        EnterFileDate: "Enter File Date",
        SelectFile: "Select File",
        SelectSubject: "Select Subject",
        SelectDivision: "Select Division",
        EnterPeriodDate: "Enter Period Date",
        AttachedFile: "Attached File",
        EnterFileName: "Enter File Name",
        PeriodDate: "Period Date",
        Keywords: "Keywords",
        FileName: "File Name",
        PdfFile: "PDF File",
        DocumentEntryEdit: "Edit Document Entry ",
        EnterKeyword: "Enter Keyword",
        PdfName: "PDF Name",
        DocFiles: "Document Files",
        SelectDoc: "Select Doc",
        SelectLocation: "Select Location",
        reqPdfName: "PDF Name Is Require",
        CreateDocFiles: "Create Document Files",
        EditDocFiles: "Edit Document Files",
        EnterPdfName: "Enter PDF Name",
        EnterKeywords: "Enter Keywords",
        EnterSubFtype: "Enter Sub File Type",
        EnterPdfDate: "Enter PDF Date",
        DocPages: "Doc Pages",
        Comments: "Comments",
        PhysicalSerialNo: "Physical Serial Number",
        PhysicalIndex: "Physical Index",
        CreateDocPages: "Create Doc Pages",
        EditDocPages: "Edit Doc Pages",
        PageNoFrom: "Page Number From",
        PageNoUpto: "Page Number Upto",
        EnterComments: "Enter Comments",
        EnterPhysicalSerialNo: "Enter Physical Serial Number",
        EnterPhysicalIndex: "Enter Physical Index",
        SelectField: "Select Field",
        DocViewer: "Document Viewer",
        SubFileType: "Sub File Type",
        ViewPdf: "View PDF",
        View: "VIEW",
        NoRecordAvailable: "No Record Available",
        NoPdfAvailable: "No PDF Available",
        AddComment: "Add Comment",
        PageNoFrom: "Page Number From",
        PageNoTo: "Page Number To",
        RelatedOficer: "Related Oficer",
        AddRow: "Add Row",
        Index: "Index!",
        SelectDevision: "Select Devision",
        SelectFileStatus: "Select File Status",
        DocumentIndexing: "Document Indexing",
        Filter: "Filter",
        Print: "Print",
        PeriodFrom: "Period From",
        PeriodTo: "Period To",
        Search: "Search",
        Clear: "Clear",
        ViewIndexPdf: "View Index PDF",
        ViewFullPdf: "View Full PDF",
        FileDefinition: "File Definition",
        SearchKeywords: "Search Keywords",
        DateFrom: "Date From",
        DateTo: "Date To",
        Complete: "Complete",
        SplitPdfToJump: "Split PDF To Jump",
        SplitPage: "Split Page",
        PdfFileName: "PDF File Name",
        PageFrom: "Page From",
        PageTo: "Page To",
        ViewFile: "View File",
        AddPdf: "Add PDF",
        DocUpload: "Document Upload",
        EnterRemark: "Enter Remark",
        EnterValue: "Enter Value",
        FileSaved: "File Saved",
        EnterMainPdf: "Enter Main PDF",
        EnterPdf: "Enter PDF",
        PdfMearge: "PDF Mearge",
        SplitMainFile: "Split Main File",
        ForRename: "For Rename",
        ForShiftCategory: "For Shift Category",
        UpdatePdf: "Update PDF",
        PdfCounter: "PDF Counter",
        EnterFolderPath: "Enter Folder Path",
        Count: "Count",
        EmployeeEntry: "Employee Entry",
        EmployeeName: "Employee Name",
        Login: "Login",
        Password: "Password",
        Edit: "Edit",
        delete: "Delete",
        Export: "Export",
        Release: "Release",
        Post: "Post",
        SelectEmployeeName: "Select Employee Name",
        ParentName: "Parent Name",
        EmployeeMaster: "Employee Master",
        EmpName: "Employee Name",
        EmpCode: "Employee Code",
        EmpStatus: "Employee Status",
        SelectState: "Select State",
        SelectCountry: "Select Country",
        SelectDistrict: "Select District",
        reqEmpName: "Employee name Is Require",
        reqEmpCode: "Employee Code is Require",
        reqFatherName: "Father Name Is Require",
        reqMobNo: "Mobile Number Is Require",
        reqPanNo: "Pan Number Is Require",
        reqJoiningDate: "Joining Date Is Require",
        reqDesignation: "Designation Is Require",
        reqDepartment: "Department Is Require",
        reqPerAddress: "Permanent Address Is Require",
        reqPinCode: "Pin Code Is Require",
        reqAdharNo: "Adhar Number Is Require",
        reqEmail: "Email Is Require",
        reqEmpdob: "Employee DOB Is Required",
        CreateEmployeeReg: "Create Employee Registration",
        EditEmployeeReg: "Edit Employee Registration",
        EnterEmpName: "Enter Employee Name",
        EnterEmpCode: "Enter Employee Code",
        EnterFatherName: "Enter Father Name",
        EnterSpauseName: "Enter Spause Name",
        EnterMotherName: "Enter Mother Name",
        EnterMobileNumber: "Enter Mobile Number",
        EnterEmail: "Enter Email",
        EnterPanNo: "Enter Pan Number",
        EnterAdharNo: "Enter Adhar Number",
        EnterDOB: "Enter Date Of Birth",
        EnterJoiningDate: "Enter Joining Date",
        EnterRetirementDate: "Enter Retirement Date",
        EnterLocalAddress: "Enter Local Address",
        EnterPerAddress: "Enter Permanent Address",
        EnterPinCode: "Enter Pin Code",
        AttachedImage: "Attached Image",
        DocManagerReport: "Doc Manager Report",
        SelectSubSubject: " Select Sub Subject",
        SubSubjectName: "Sub Subject Name",
        DivisionName: "Division Name",
        Remark: "Remark",
        SessionYear: "Session Year",
        InActive: "InActive",
        Active: "Active",
        TotalDoc: "Total Document",
        TotalType: "Total Type",
        TotalIndexFile: "Total Index File",
        TotalSplitFile: "Total Split File",
        Zone: "Zone",
        LineChart: "Line Chart",
        Department: "Department",
        AcademicDepartment: "Academic Department",
        DocumentManagementSystem: "Document Management System",
        DocMng: "Document Manager",
        PartNo: "Part Number",
        PeriodFileNo: "Period File Number",
        AuthonticatedPerson: "Authonticated Person",
        FileDate: "File Date",
        SubjectId: "Subject ID",
        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        DesignationMaster: "Designation Master",

        enteritemType: "Enter Item Type",
        enteritemTypecode: "Enter Item Type Code",
        itemType: "Item Type",
        itemTypecode: "Item Type Code",
        ItemType: "Item Type",
        entertaxName: "Enter Tax Name",
        entertaxPercentage: "Enter Tax Percentage",
        entereffectiveDate: "Enter Effective Date",
        taxName: "Tax Name",
        taxPercentage: "Tax Percentage",
        effectiveDate: "Effective Date",
        TaxMaster: "Tax Master",
        unitName: "Unit Name",
        unitShortname: "Unit Short Name",
        UnitMaster: "Unit Master",
        enterunitName: "Enter Unit Name",
        enterunitShortname: "Enter Unit Short Name",
        enteritemName: "Enter Item Name",
        enteritemCode: "Enter Item Code",
        enteritemTypeId: "Enter Item Type ID",
        enterempId: "Enter Employee ID",
        entertaxId: "Enter Tax ID",
        itemCategory: "Enter Item Category",
        enterunitId: "Enter Unit ID",
        entermodelNo: "Enter Model No",
        enterserialNo: "Enter Serial No",
        entervehicleNo: "Enter Vehicle No",
        enterchesisNo: "Enter Chesis No",
        enterhsnCode: "Enter hsn Code",
        enteritemWeight: "Enter Item Weight",
        enterdepreciationRate: "Enter Depreciation Rate",
        enterpurchaseYear: "Enter Purchase Year",
        itemName: "Item Name",
        itemCode: "Item Code",
        purchaseYear: "Purchase Year",
        modelNo: "ModelNo",
        serialNo: "SerialNo",
        vehicleNo: "VehicleNo",
        hsnCode: "hsncode",
        itemWeight: "Item Weight",
        ItemMaster: "Item Master",
        Purchaseorder: "Purchase Order",
        entryNo: "EntryNo",
        batchNo: "BatchNo",
        itemId: "ItemId",
        unitID: "UnitId",
        rate: "Rate",
        inQty: "inQty",
        outQty: "outQty",
        voucherId: "VoucherId",
        stockBinId: "StockBinId",
        voucherType: "Voucher Type",
        voucherDate: "Voucher Date",
        expiryDate: "Expiry Date",
        companyId: "CompanyId",
        gstRate: "gstRate",
        cgst: "cgst",
        sgst: "sgst",
        igst: "igst",
        gstid: "gstid",
        cgstid: "cgstid",
        sgstid: "sgstid",
        igstid: "igstid",
        StockLedger: "StockLedger",
        enterentryNo: "Enter EnteryNo",
        enterbatchNo: "Entery BatchNo",
        enteritemId: "Enter ItemId",
        enterunitID: "Enter UnitId",
        enterrate: "Enter Rate",
        enterinQty: "Enter inQty ",
        enteroutQty: "Enter outQty",
        entervoucherId: "Enter VoucherId",
        entervoucherType: "Enter Voucher Type",
        entervoucherDate: "Enter Voucher Date",
        enterexpiryDate: "Enter Expiry Date",
        entergstRate: "Enter gstRate ",
        entercgst: "Enter cgst",
        entersgst: "Enter sgst",
        enterigst: "Enter igst",
        entergstid: "Enter gstid",
        entersgstid: "Enter sgstid",
        enterigstid: "Enter igstid",
        itemCategory: "itemCategory",
        itemCategoryAbbre: "ItemCategoryAbbre",
        parentId: "ParentId",
        taxId: "TaxId",
        enteritemCategory: "Enter Item Category",
        enteritemCategoryAbbre: "Enter Item CategoryAbbre",
        entertaxId: "Enter TaxId",
        enterparentId: "Enter ParentId",
        ItemCategory: "ItemCategory",

        JurisdictionMaster: "Jurisdiction Master",
        EnterJurisdictionName: "Enter Jurisdiction Name",
        SelectNode: "Select Node",
        NodePermission: "Node Permission",
        SelectUser: "Select User",
        PollMaster: "Poll Master",
        CreatePollMaster: "Create Poll Master",
        poleName: "Pole Name",
        SelectPollType: "Select Poll Type",
        Hight: "Hight",
        wight: "Weight",
        Thickness: "Thickness",
        poleColor: "Pole Color",
        underGroundPoleHight: "Under Ground Pole Hight",
        numOfLightAttach: "Number Of Light Attach",
        currentStatus: "Current Status",
        poleImg: "Pole Image",
        EditPollMaster: "Edit Poll Master",

        PoleType: "Pole Type",
        PoleTypeName: "Pole Type Name",

        //Inventory Module
        CreateIndent: "Create Indent",
        EditIndent: "Edit Indent",
        estimateNo: "Enter estimate No",
        emp_name: "Enter Employee Name",
        indentDate: "Select indent Date",

        // email system
        EmailSystem: "Email System",

        //  VTS dashboard And Report

        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        Dashboard: "Dashboard",
        Tracking: "Tracking",
        GeofacingCreate: "Geofencing Create",
        KudagharLocation: "Kudaghar Location",
        VehicleHistory: "Vehicle History",
        VehicleTravelled: "Vehicle Travelled",
        VehicleNotMoved: "Vehicle Not Moved",
        VehicleDetailsSummery: "Vehicle Details Summary",
        ProbableWireTempering: "Probable Wire Tempering",
        FuelConsumption: "Fuel Consumption",
        FuelConspWithoughtOpening: "Fuel Consumption Without Opening",
        FuelConspWithOpening: "Fuel Consumption With Opening",
        VehicleTrack: "Vehicle Track",
        Period: "Period",
        VehicleType: "Vehicle Type",
        VehicleNo: "Vehicle Number",
        Latitute: "Latitute",
        Longitude: "Longitude",
        Radius: "Radius",
        FenceName: "Fence Name",
        TrackingDate: "Tracking Date",
        Speed: "Speed",
        HelpDesk: "Help Desk",
        HelpCreation: "Help Creation",
        PageTitle: "Page Title",

        // DepartmentName:'Department Name',
        Date: "Date",
        Devid: "Device Id",
        TrackTime: "Track Time",
        kmPerLitre: "Km Per Litre",
        Ignition: "Ignition",
        Distance: "Distance",
        FuelConsumed: "Fuel Consumed",
        Duration: "Duration",
        Driver: "Driver",

        DepartmentName: "Department Name",
        Date: "Date",
        Devid: "Device Id",
        TrackTime: "Track Time",
        kmPerLitre: "Km Per Litre",
        Ignition: "Ignition",
        Distance: "Distance",
        FuelConsumed: "Fuel Consumed",
        Duration: "Duration",
        Driver: "Driver",
        Polygon: "Polygon",
        Running: "Running",
        Idle: "Idle",
        StartTime: "Start Time",
        EndTime: "End Time",
        BinLocation: "Bin Location",

        DistanceKm: "Distance(Km)",
        avgSpeed: "Avg. Speed",
        TimeConsuption: "Time Consuption",
        MileageKmLtr: "Mileage(Km/Ltr)",
        FuelAlloted: "Fuel Alloted",
        TotFuelAllot: "Total Fuel Alloted",
        TotalDays: "Total Days",
        DistanceAlloted: "Distance Alloted",
        ActualDistance: "Actual Distance",
        DistanceAlloted: "Distance Alloted",
        BalanceDist: "Balance Dist",
        BalanceFuel: "Balance Fuel",

        reqVehicleNum: "Vehicle number is required",
        SelectVehicleNo: "Select Vehicle Number",
        SelectVehicleType: "Select Vehicle Type",

        //validations
        reqHSNCode: "HSN code is required",
        reqSimNum: "Sim number is required",
        reqBrandName: "Brand Name is required",
        reqBrandCode: "Brand Code is required",
        reqShortName: "Short Name is required",
        reqFuelType: "Fuel Type Name is required",
        reqFuelCode: "Fuel Code is required",
        reqVehicleType: "Vehicle Type Name is required",
        reqVehicleCode: "Vehicle Code is required",

        enteritemType: "Enter Item Type",
        enteritemTypecode: "Enter Item Type Code",
        itemType: "Item Type",
        itemTypecode: "Item Type Code",
        ItemType: "Item Type",
        entertaxName: "Enter Tax Name",
        entertaxPercentage: "Enter Tax Percentage",
        entereffectiveDate: "Enter Effective Date",
        taxName: "Tax Name",
        taxPercentage: "Tax Percentage",
        effectiveDate: "Effective Date",
        TaxMaster: "Tax Master",
        unitName: "Unit Name",
        unitShortname: "Unit Short Name",
        UnitMaster: "Unit Master",
        enterunitName: "Enter Unit Name",
        enterunitShortname: "Enter Unit Short Name",
        enteritemName: "Enter Item Name",
        enteritemCode: "Enter Item Code",
        enteritemTypeId: "Enter Item Type ID",
        enterempId: "Enter Employee ID",
        entertaxId: "Enter Tax ID",
        itemCategory: "Enter Item Category",
        enterunitId: "Enter Unit ID",
        entermodelNo: "Enter Model No",
        enterserialNo: "Enter Serial No",
        entervehicleNo: "Enter Vehicle No",
        enterchesisNo: "Enter Chesis No",
        enterhsnCode: "Enter hsn Code",
        enteritemWeight: "Enter Item Weight",
        enterdepreciationRate: "Enter Depreciation Rate",
        enterpurchaseYear: "Enter Purchase Year",
        itemName: "Item Name",
        itemCode: "Item Code",
        purchaseYear: "Purchase Year",
        modelNo: "ModelNo",
        serialNo: "SerialNo",
        vehicleNo: "VehicleNo",
        hsnCode: "hsncode",
        itemWeight: "Item Weight",
        ItemMaster: "Item Master",
        Purchaseorder: "Purchase Order",
        entryNo: "EntryNo",
        batchNo: "BatchNo",
        itemId: "ItemId",
        unitID: "UnitId",
        rate: "Rate",
        inQty: "inQty",
        outQty: "outQty",
        voucherId: "VoucherId",
        stockBinId: "StockBinId",
        voucherType: "Voucher Type",
        voucherDate: "Voucher Date",
        expiryDate: "Expiry Date",
        companyId: "CompanyId",
        gstRate: "gstRate",
        cgst: "cgst",
        sgst: "sgst",
        igst: "igst",
        gstid: "gstid",
        cgstid: "cgstid",
        sgstid: "sgstid",
        igstid: "igstid",
        StockLedger: "StockLedger",
        enterentryNo: "Enter EnteryNo",
        enterbatchNo: "Entery BatchNo",
        enteritemId: "Enter ItemId",
        enterunitID: "Enter UnitId",
        enterrate: "Enter Rate",
        enterinQty: "Enter inQty ",
        enteroutQty: "Enter outQty",
        entervoucherId: "Enter VoucherId",
        entervoucherType: "Enter Voucher Type",
        entervoucherDate: "Enter Voucher Date",
        enterexpiryDate: "Enter Expiry Date",
        entergstRate: "Enter gstRate ",
        entercgst: "Enter cgst",
        entersgst: "Enter sgst",
        enterigst: "Enter igst",
        entergstid: "Enter gstid",
        entersgstid: "Enter sgstid",
        enterigstid: "Enter igstid",
        itemCategory: "itemCategory",
        itemCategoryAbbre: "ItemCategoryAbbre",
        parentId: "ParentId",
        taxId: "TaxId",
        enteritemCategory: "Enter Item Category",
        enteritemCategoryAbbre: "Enter Item CategoryAbbre",
        entertaxId: "Enter TaxId",
        enterparentId: "Enter ParentId",
        ItemCategory: "ItemCategory",

        JurisdictionMaster: "Jurisdiction Master",
        EnterJurisdictionName: "Enter Jurisdiction Name",
        SelectNode: "Select Node",
        NodePermission: "Node Permission",
        SelectUser: "Select User",
        PollMaster: "Poll Master",
        CreatePollMaster: "Create Poll Master",
        poleName: "Pole Name",
        SelectPollType: "Select Poll Type",
        Hight: "Hight",
        wight: "Weight",
        Thickness: "Thickness",
        poleColor: "Pole Color",
        underGroundPoleHight: "Under Ground Pole Hight",
        numOfLightAttach: "Number Of Light Attach",
        currentStatus: "Current Status",
        poleImg: "Pole Image",
        EditPollMaster: "Edit Poll Master",

        PoleType: "Pole Type",
        PoleTypeName: "Pole Type Name",

        //Inventory Module
        CreateIndent: "Create Indent",
        EditIndent: "Edit Indent",
        estimateNo: "Enter estimate No",
        emp_name: "Enter Employee Name",
        indentDate: "Select indent Date",

        // email system
        EmailSystem: "Email System",

        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        Dashboard: "Dashboard",
        Tracking: "Tracking",
        GeofacingCreate: "Geofencing Create",
        KudagharLocation: "Kudaghar Location",
        VehicleHistory: "Vehicle History",
        VehicleTravelled: "Vehicle Travelled",
        VehicleNotMoved: "Vehicle Not Moved",
        VehicleDetailsSummery: "Vehicle Details Summary",
        ProbableWireTempering: "Probable Wire Tempering",
        FuelConsumption: "Fuel Consumption",
        FuelConspWithoughtOpening: "Fuel Consumption Without Opening",
        FuelConspWithOpening: "Fuel Consumption With Opening",
        VehicleTrack: "Vehicle Track",
        Period: "Period",
        VehicleType: "Vehicle Type",
        VehicleNo: "Vehicle Number",
        Latitute: "Latitute",
        Longitude: "Longitude",
        Radius: "Radius",
        FenceName: "Fence Name",
        TrackingDate: "Tracking Date",
        Speed: "Speed",
        HelpDesk: "Help Desk",
        HelpCreation: "Help Creation",
        PageTitle: "Page Title",
        DepartmentName: "Department Name",
        Date: "Date",
        Devid: "Device Id",
        reqModelNo: "Model Number Is Required",
        requiredShortName: "Short Name Is Required",
        EmpNameRequired: "Employee Name IS Required",
        EmpCodeRequired: "Employee Code Is Required",
        FatherNameRequired: "Father Name Is Required",
        MobNoRequired: "Mobile Number Is Required",
        PanNoRequired: "Pan Number Is Required",
        AdharNoRequired: "Adhar Number Is Required",
        DobRequired: "Dob Is Required",
        JoiningDateRequired: "Joining Date Is Required",
        DepartmentRequired: "Department Is Required",
        PermanentAddressRequired: "Permanent Address Is Required",
        Organization: "Organization",
        AddOrganization: "Add Organization",
        EditOrganization: "Edit Organization",
        ResiNO: "Resi. NO",
        Fax: "Fax",
        Website: "Website",
        DistrictArea: "District Area",
        StatusPg: "Status Pg",
        Registrar: "Registrar",
        NameOfFaculties: "Name Of Faculties",
        NoOfTeachers: "No Of Teachers",
        AccesedByNaac: "Accesed By Naac",
        ReAtendenceDuration: "Re Atendence Duration",
        EnableAutoStuCredentials: "Enable Auto Student Credentials",
        SelectEmployeeRoles: "Select Employee Roles",
        EnableBiometric: "Enable Biometric",
        EnableDualBiometric: "Enable Dual Biometric",
        MenuType: "Menu Type",
        SelectParentInstitute: "Select Parent Institute",
        MenuBackColor: "Menu Back Color",
        MenuOverColor: "Menu Over Color",
        Attachedlogo: "Attached logo",
        UploadImage: "Upload Image",
        ReportHeaderImg: "Report Header Img",
        ReportFooterImg: "Report Footer Img",
        ReportHeader: "Report Header",
        SelectStudentRoles: "Select Student Roles",
        EnableAutoEmpCredentials: "Enable Auto Employee Credentials",
        ShowAcademicSession: "Show Academic Session",
        ShowFinancialYear: "Show Financial Year",
        EditAcademicSession: "Edit Academic Session",
        EditableFinancialYear: "Editable Financial Year",
        DefaultJurisdiction: "Default Jurisdiction",
        OrgType: "Org. Type",
        School: "School",
        College: "College",
        University: "University",
        Institute: "Institute",
        YearOfEstablishment: "Year Of Establishment",
        Principal: "Principal",
        collegeStatus: "College Status",
        ResidencialAddress: "Residencial Address",
        collegeStatus: "College Status",
        District: "District",
        TrackerData: "Tracker Data",
        UniqueId: "Unique Id",
        PositionId: "Position Id",
        Lastupdate: "Last Update",
        correctionDate: "Correction Date",
        PageName: "Page Name",
        SendEmail: "Send Email",
        UpdateSendEmail: "Update Send Email",
        Latitude: "Latitude",

        reqCountryName: "Required Country Name",
        reqZoneName: "Required Zone Name",
        reqdeptName: "Required department name",
        reqDLNO: "Dl no is required",
        PincodeRequired: "Pincode is required",

        DistanceKm: "Distance (Km)",
        Speedkmh: "Speed (km/h)",
      },

      content: {},
    },
  },
  hi: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: {
        //VehicleDetail
        userid: "यूजर आईडी दर्ज करें",
        password: "पासवर्ड दर्ज करें",
        role: "भूमिका चुनें",

        VehicleTypeName11: "वाहन प्रकार",
        EnterDesignationCode: "डिज़ाइनशन कोड दर्ज करें",
        EnterDesignation: "डिज़ाइनशन नाम दर्ज करें",
        empStatus: "स्थिति चुनें",
        EnterCode: "कोड दर्ज करें",
        SelectZone: "क्षेत्र चुनें",
        DesignationCode1: "पद कोड",
        eScarp1: "एस्क्रैप भी सहेजें",
        PetrolPumpName1: "पेट्रोल पंप का नाम",
        SelectStatus: "स्थिति चुनें",
        Emaileventname1: "ईमेल इवेंट का नाम",
        Emaileventtype1: "ईमेल इवेंट का प्रकार",

        Emailcampaigname1: "ईमेल अभियान का नाम",
        Status1: "स्थिति",
        Emailcampaign: "ईमेल अभियान बनाएं",
        toTime: "समाप्ति समय",
        listGroups: "समूह चुनें",
        listMembers: "सदस्य चुनें",
        Emailcampaign1: "ईमेल अभियान",
        EditEmailcampaign: "ईमेल अभियान संपादित करें",
        EnterEmployeeName: "कर्मचारी का नाम दर्ज करें",
        EnterEmployeeCode: "कर्मचारी कोड दर्ज करें",
        EnterAdharNumber: "आधार नंबर दर्ज करें",
        SelectCity: "शहर चुनें",
        EnterPermanentAddress: "स्थायी पता दर्ज करें",
        EnterPincode: "पिनकोड दर्ज करें",
        AttachedSignature: "हस्ताक्षर संलग्न करें",
        CreateEmployeeRegistration: "कर्मचारी मास्टर पंजीकरण बनाएं",
        EnterDrivingLicense: "ड्राइविंग लाइसेंस नंबर दर्ज करें",
        SaveEscrapAlso: "एस्क्रैप भी सहेजें",
        Designation1: "पद चुनें",

        AddDesignation: "पद बनाएं",
        email12: "ईमेल",
        isActive12: "वर्तमान में सक्रिय",
        Emailsettingmaster: "ईमेल सेटिंग्स",
        Type: "प्रकार चुनें",
        isActive: "स्थिति",
        AddEmaileventsetting: "ईमेल इवेंट सेटिंग बनाएं",
        EditEmaileventsetting: "ईमेल इवेंट सेटिंग संपादित करें",
        EmailtoDate: "समाप्ति तिथि",
        EMAIL: "ईमेल",
        SMS: "एसएमएस",
        templateId: "टेम्पलेट आईडी दर्ज करें",
        DepartmentName1: "विभाग का नाम दर्ज करें",
        DepartmentName: "विभाग का नाम",
        wiretemp: "वायर टेम्पलेट",
        Empdeptmaster: "विभाग मास्टर",
        Departmentshortname1: "विभाग का संक्षिप्त नाम दर्ज करें",
        Departmentshortname: "विभाग का संक्षिप्त नाम",
        Headofdpt1: "विभाग प्रमुख चुनें",
        Editempdept: "विभाग संपादित करें",
        EMAILGroup: "ईमेल समूह",
        SMSGroup: "एसएमएस समूह",

        CampaignTemplate: "अभियान टेम्पलेट",
        smsTemplateID: "एसएमएस टेम्पलेट आईडी दर्ज करें",
        smsTemplateID1: "एसएमएस टेम्पलेट आईडी",
        template: "टेम्पलेट",
        templateType: "टेम्पलेट प्रकार",
        EditCampaignTemplate: "अभियान टेम्पलेट संपादित करें",
        AddCampaignTemplate: "अभियान टेम्पलेट बनाएं",

        EditEmployeeRegistration: "कर्मचारी मास्टर पंजीकरण संपादित करें",
        VehicleDetailAdd: "वाहन विवरण बनाएं",
        VehicleDetailEdit: "वाहन विवरण संपादित करें",
        VehicleDetail: "वाहन की सूचना",
        VehicleName: "वाहन का नाम दर्ज करें",
        Code: "कोड दर्ज करें",
        HsnCode: "एचएसएन कोड दर्ज करें",
        Category: "वर्ग चुनें",
        VehicleType: "वाहन का प्रकार चुनें",
        EnterUnit: "इकाई दर्ज करें चुनें",
        Tax: "कर चुनें",
        ModelNo: "प्रतिरूप संख्या दर्ज करें",
        VehicleNo: "वाहन नं दर्ज करें",
        SimNo: "सिम नं दर्ज करें",
        SimType: "सिम प्रकार चुनें",
        SimCompanyName: "सिम कंपनी का नाम दर्ज करें",
        SerialNo: "सीरीयल नम्बर दर्ज करें",
        ChasisNo: "चेसिस नं दर्ज करें",
        PurchaseYear: "खरीद वर्ष",
        UnderControlOF: "के नियंत्रण में चुनें",
        Department: "विभाग दर्ज करें",
        Designation: "पद का नाम दर्ज करें",
        VehicleType: "वाहन का प्रकार चुनें",
        BrandType: "ब्रांड प्रकार चुनें",
        FuelType: "ईंधन प्रकार चुनें",
        Weight: "वजन (किग्रा) दर्ज करें",
        LitrePerHour: "प्रति घंटा लीटर दर्ज करें",
        KMperLitre: "किलोमीटर प्रति लीटर दर्ज करें",
        DeviceNo: "डिवाइस नं दर्ज करें",
        DeviceType: "डिवाइस का प्रकार चुनें",
        RFID1: "आरएफआईडी1 दर्ज करें",
        RFID2: "आरएफआईडी2  दर्ज करें",
        AllotedFuel: "आवंटित ईंधन दर्ज करें",
        EnterZone: "जोन चुनें",
        EnterDepartment: "विभाग चुनें",
        //grid
        Designations: "पद का नाम",
        Departments: "विभाग",
        VehicleNos: "वाहन नं",
        //brand master
        BrandMaster: "ब्रांड मास्टर",
        BrandMasterAdd: "ब्रांड मास्टर बनाएं",
        BrandMasterEdit: "ब्रांड मास्टर संपादित करें",
        BrandName: "ब्रांड नाम दर्ज करें",
        BrandCode: "ब्रांड कोड दर्ज करें",
        ShortName: "संक्षिप्त नाम दर्ज करें",
        //grid
        BrandNames: "ब्रांड नाम",
        BrandCodes: "ब्रांड कोड",
        BrandShortNames: "संक्षिप्त नाम",

        //fuel Type
        FuelTypes: "ईंधन प्रकार",
        FuelTypeAdd: "ईंधन प्रकार बनाएँ",
        FuelTypeEdit: "ईंधन प्रकार संपादित करें",
        FuelTypeName: "ईंधन प्रकार का नाम दर्ज करें",
        FuelCode: "ईंधन कोड दर्ज करें",
        FuelShortName: "ईंधन संक्षिप्त नाम दर्ज करें",
        //grid
        FuelTypeNames: "ईंधन प्रकार का नाम",
        FuelCodes: "ईंधन कोड",
        FuelShortNames: "ईंधन का संक्षिप्त नाम",

        //Vehicletype
        VehicleTypes: "वाहन का प्रकार",
        VehicleTypeAdd: "वाहन का प्रकार बनाएं",
        VehicleTypeEdit: "वाहन का प्रकार संपादित करें",
        VehicleTypeName1: "वाहन के प्रकार का नाम दर्ज करें",
        VehicleCode: "वाहन कोड दर्ज करें",
        VehicleShortName: "वाहन का संक्षिप्त नाम दर्ज करें",
        //grid
        VehicleTypeNames: "वाहन के प्रकार का नाम",
        VehicleCodes: "वाहन कोड ",
        VehicleShortNames: "वाहन का संक्षिप्त नाम ",

        //vehicletypeIfo
        VehicleTypeInfo: "वाहन के प्रकार की जानकारी",
        VehicleTypeInfoAdd: "वाहन के प्रकार की जानकारी बनाएँ",
        VehicleTypeInfoEdit: "वाहन के प्रकार की जानकारी संपादित करें",
        PetrolPumpName: "पेट्रोलपंप का नाम दर्ज करें",
        EffectiveDate: "प्रभावी तिथि दर्ज करें",
        VehicleTypeName: "वाहन का प्रकार चुनें",
        Shift1: "शिफ्ट-1(ईंधन(एलटी)) दर्ज करें",
        Shift2: "शिफ्ट-2(ईंधन(एलटी)) दर्ज करें",
        PetrolPump: "पेट्रोलपंप चुनें",
        //grid
        FirstSessionFuelLts: "प्रथम सत्र ईंधन (लीटर)",
        SecondSessionFuelLts: "दूसरे सत्र का ईंधन (लीटर)",
        PetrolPumps: "पेट्रोलपम्प",
        EffectiveDates: "प्रभावी तिथि",

        //VehicleAudit
        NewInstallation: "नई स्थापना",
        Updation: "अद्यतनीकरण",
        VehicleAudit: "वाहन ऑडिट",
        VehicleAuditAdd: "वाहन ऑडिट बनाएँ",
        VehicleAuditEdit: "वाहन ऑडिट संपादित करें",
        VehicleNos1: "वाहन क्रमांक चुनें",
        DriverName: "ड्राइवर का नाम दर्ज करें",
        DriverMobileNo: "ड्राइवर का मोबाइल नंबर दर्ज करें",
        ServiceEngg: "सर्विस इंजीनियर दर्ज करें",
        SimNo: "सिम नंबर दर्ज करें",
        OldSimNo: "पुराना सिम नंबर दर्ज करें",
        DeviceNo: "डिवाइस नंबर दर्ज करें",
        OldDeviceNo: "पुराना डिवाइस नं दर्ज करें",
        ProblemType: "समस्या प्रकार का चयन करें",
        Remark1: "टिप्पणी दर्ज करें",
        Image: "Upload Image",
        VehicleNo12: "वाहन नं",
        ServiceEng1: "सर्विस इंजीनियर",
        name: "नाम",
        name1: "नाम दर्ज करें",
        description1: "विवरण दर्ज करें",
        description: "विवरण",
        Creategroupmaster: "समूह बनाएं",
        Groupmaster: "समूह",
        Editgroupmaster: "समूह संपादित करें",
        //FuelBalCorrection
        FuelBalCorrection: "ईंधन बाल सुधार",
        FuelBalCorrectionAdd: "ईंधन बाल सुधार बनाएँ",
        FuelBalCorrectionEdit: "ईंधन बाल सुधार संपादित करें",
        VehicleNo: "वाहन क्रमांक चुनें",

        //aniket             ,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
        AddDepartment: "विभाग बनाएं",
        EditDepartment: "विभाग संपादित करें",

        DesignationMaster: "पद मास्टर",
        //area ward
        AreaName: "क्षेत्र का नाम",
        WardNumber: "वार्ड संख्या ",
        Zone: "ज़ोन",
        AreaWard: "क्षेत्र/वार्ड",
        AreaWardEdit: "क्षेत्र/वार्ड संपादित करें",
        EnterAreaName: "क्षेत्र का नाम दर्ज करें",
        EnterWardNumber: "वार्ड का नाम दर्ज करें",
        EnterZoneName: "ज़ोन का नाम दर्ज करें",

        //BinKudaghar
        BinKudaghar: "बिन/कूड़ाघर",
        BinSrNo: "क्रमांक",
        BinName: "बिन नाम",
        BinCode: "बिन कोड",
        BinRFID: "आरएफआईडी",
        BinArea: "क्षेत्र",
        BinWard: "वार्ड",
        BinZone: "जोन",
        BinLatitude: "अक्षांश",
        BinLongitude: "देशान्तर",
        AddBin: "बिन जोड़ें",
        EnterBinAreaName: "क्षेत्र का नाम दर्ज करें",
        EnterBinWardNumber: "वार्ड संख्या दर्ज करें",
        EnterBinZone: "ज़ोन दर्ज करें",
        EnterBinName: "बिन नाम दर्ज करें",
        EnterBinCode: "बिन कोड दर्ज करें",
        EnterBinRFID: "बिन आरएफआईडी दर्ज करें",
        EnterBinDesc: "बिन विवरण दर्ज करें",
        EditBinData: "बिन डेटा संपादित करें",

        //HandheldInfo
        HandheldInfo: "हैंडहेल्ड जानकारी",
        HandheldDeviceName: "डिवाइस का नाम",
        HandheldDeviceCode: "डिवाइस कोड",
        EnterDeviceName: "डिवाइस का नाम दर्ज करें",
        EnterDeviceCode: "डिवाइस कोड दर्ज करें",
        AddHandheldInfo: "हैंडहेल्ड जानकारी जोड़ें",
        EditHandheldInfo: "हैंडहेल्ड जानकारी संपादित करें",

        //RouteDetail
        RouteDetail: "मार्ग विवरण",
        RouteName: "मार्ग का नाम",
        RouteDesc: "मार्ग विवरण",
        RouteDate: "रूट दिनांक",
        AddRouteDetail: "मार्ग विवरण जोड़ें",
        EditRouteDetail: "मार्ग विवरण संपादित करें",
        EnterRouteName: "मार्ग का नाम दर्ज करें",
        EnterRouteDesc: "मार्ग विवरण दर्ज करें",
        EnterRouteDate: "रूट दिनांक दर्ज करें",

        //RosterPlan
        RosterPlan: "रोस्टर योजना",
        RosterNumber: "रोस्टर संख्या",
        RosterDate: "रोस्टर दिनांक",
        RosterFromDate: "दिनांक से",
        RosterToDate: "दिनांक तक",
        AddRosterPlan: "रोस्टर योजना जोड़ें",
        EditRosterPlan: "रोस्टर योजना संपादित करें",
        EnterRosterNumber: "रोस्टर संख्या दर्ज करें",
        EnterRosterDate: "रोस्टर दिनांक दर्ज करें",
        EnterRosterFromDate: "दिनांक से दर्ज करें",
        EnterRosterToDate: "दिनांक तक दर्ज करें",

        //BinKudagharPriority
        BinPriority: "बिन/कूड़ाघर प्राथमिकता",
        BinPriorityRouteName: "मार्ग का नाम",
        BinPriorityDesc: "विवरण",
        BinPriorityDate: "मार्ग दिनांक",
        EnterBinRouteName: "मार्ग का नाम दर्ज करें",
        EnterBinRouteDate: "रूट दिनांक दर्ज करें",
        EnterBinDesc: "विवरण दर्ज करें",
        EnterBinTime: "समय दर्ज करें",
        EnterBinTimeInterval: "समय अंतराल दर्ज करें",
        AddBinPriority: "बिन/कूड़ाघर प्राथमिकता जोड़ें",
        EditBinPriority: "बिन/कूड़ाघर प्राथमिकता संपादित करें",

        zoneMaster: "ज़ोन मास्टर",
        add: "जोड़ें",
        print: "प्रिंट",
        Active: "सक्रिय",
        InActive: "निष्क्रिय",
        Action: "क्रिया",
        SrNo: "क्रम संख्या",
        zoneName: "जोन का नाम",
        zoneCode: "ज़ोन कोड",
        Status: "स्थिति",
        search: "खोजें",
        save: "सहेजें",
        reset: "रीसेट करें",
        createZoneMaster: "ज़ोन मास्टर बनाएं",
        editZoneMaster: "ज़ोन मास्टर संपादित करें",
        enterZoneName: "ज़ोन का नाम ",
        enterZoneCode: "ज़ोन का कोड ",
        req: "ज़ोन का नाम आवश्यक है",
        update: "अपडेट",
        wardMaster: "वार्ड मास्टर",
        wardName: "वार्ड का नाम",
        wardCode: "वार्ड कोड",
        createWardMaster: "वार्ड मास्टर बनाएं",
        editWardMaster: "वार्ड मास्टर संपादित करें",
        enterWardName: "वार्ड का नाम ",
        enterWardCode: "वार्ड का कोड ",
        req1: "वार्ड का नाम आवश्यक है",
        SelectZoneName: "जोन का नाम चुनें",
        reqSelectZoneName: "आवश्यक जोन नाम का चयन करें",
        CategoryMaster: "श्रेणी मास्टर",
        CategoryName: "श्रेणी नाम",
        EnterCategoryName: "श्रेणी का नाम दर्ज करें",
        CreateCategoryMaster: "श्रेणी मास्टर बनाएं",
        reqCategory: "आवश्यक श्रेणी नाम दर्ज करें",
        EditCategoryMaster: "श्रेणी मास्टर संपादित करें",
        SubCategoryMaster: "उप श्रेणी मास्टर",
        SubCategoryName: "उप श्रेणी का नाम",
        RemarkName: "टिप्पणी",
        CreateSubCategoryMaster: "उपश्रेणी मास्टर बनाएँ",
        EnterSubCategoryName: "उप श्रेणी का नाम दर्ज करें",
        EnterCategoryRemark: "श्रेणी टिप्पणी दर्ज करें",
        reqSelectCategory: "*कृपया श्रेणी चुनें",
        reqEnterSubCategory: "उप श्रेणी नाम दर्ज करना आवश्यक होना चाहिए",
        SelectCategory: "श्रेणी चुनना",
        EditSubCategoryMaster: "उपश्रेणी मास्टर संपादित करें",

        FromDate: "तारीख से",
        Todate: "तारीख तक",

        Description: "विवरण",
        MaxLength: "लंबाई",
        MaxWidth: "चौड़ाई",
        MaxHeight: "ऊँचाई",
        AreaSquareMeter: "क्षेत्रफल वर्ग मीटर",
        ratePerSqMtr: "दर प्रति वर्गमीटर",
        Amount: "मात्रा",
        Premium: "अधिमूल्य",

        MenuMaster: " मेनू मास्टर",
        ParentName: "अभिभावक का नाम",
        MenuName: "मेनू नाम",
        PageURL: "पेज यूआरएल",
        Icon: "आइकन",
        CreateMenuMaster: "मेनू मास्टर बनाएं",
        EnterMenuName: "मेनू नाम दर्ज करें",
        EnterPageURL: "पेज यूआरएल दर्ज करें",
        EnterIcon: "चिह्न दर्ज करें",
        selectParentMenuName: "पेरेंट मेनू नाम चुनें",
        reqMenuName: "मेनू नाम आवश्यक है",
        EditMenuMaster: "मेनू मास्टर संपादित करें",
        RoleMaster: " रोल मास्टर",
        RoleName: "भूमिका का नाम",
        UserPermissionMaster: "उपयोगकर्ता अनुमति मास्टर",
        UserName: "उपयोगकर्ता नाम",
        CountryMaster: "देश मास्टर",
        CountryName: "देश  का नाम",
        CountryCode: "देश कोड",
        Nationality: "राष्ट्रीयता",
        CreateCountryName: "देश का नाम बनाएं",
        EnterCountryName: "देश का नाम दर्ज करें",
        EnterCountryCode: "देश कोड दर्ज करें",
        EnterNationality: "राष्ट्रीयता दर्ज करें",
        EditCountryMaster: "देश मास्टर संपादित करें",
        StateMaster: "राज्य मास्टर",
        StateName: "राज्य का नाम",
        StateCode: "राज्य कोड",
        CreateStateMaster: "राज्य मास्टर बनाएं",
        EnterStateName: "राज्य का नाम दर्ज करें",
        EnterStateCode: "राज्य कोड दर्ज करें",
        SelectCountryName: "देश का नाम चुनें",
        EditStateMaster: "राज्य मास्टर संपादित करें",
        DistrictMaster: "ज़िला मास्टर",
        DistrictName: "ज़िला का नाम",
        DistrictCode: "ज़िला कोड",
        CreateDistrictMaster: "ज़िला का नाम दर्ज करें",
        EnterDistrictName: "ज़िला का नाम दर्ज करें",
        EnterDistrictCode: "ज़िला कोड दर्ज करें",
        SelectStateName: "राज्य  का नाम चुनें",
        EditDistrictMaster: "ज़िला  मास्टर संपादित करें",
        GenderMaster: "लिंग मास्टर",
        GenderName: "लिंग का नाम",
        GenderCode: "लिंग कोड",
        CreateGenderMaster: "लिंग का नाम दर्ज करें",
        reqGenderName: "लिंग नाम आवश्यक है",
        EnterGenderName: "लिंग का नाम दर्ज करें",
        EnterGenderCode: "लिंग कोड दर्ज करें",
        SelectGenderName: "लिंग का नाम चुनें",
        EditGenderMaster: "लिंग  मास्टर संपादित करें",

        Total: "कुल",
        RegNo: " संख्या",
        NameOfPlace: "उप विज्ञापन के प्रकार का नाम",
        Size: "आकार",
        Sqmtr: "वर्ग मीटर",
        Rate: "दर",
        NetAmount: "शुद्ध राशि",
        PaymentMode: "भुगतान का प्रकार",
        Deposit: "जमा",
        Remaining: "शेष",

        Date: "तारीख",

        CreateDirectApplyforAdvertisement: "विज्ञापन के लिए सीधा आवेदन बनाएं",

        UserManegment: "प्रयोक्ता प्रबंधन",
        FirstName: "पहला नाम",
        LoginName: "लॉगिन नाम",
        MobileNo: "मोबाइल नंबर",
        Email: "ईमेल",
        DateOfBirth: "जन्म की तारीख",
        Role: "भूमिका",
        SelectGender: "लिंग चुनें",
        SelectRole: "भूमिका चुनें",
        SelectUserType: "उपयोगकर्ता प्रकार चुनें",
        CreateUserManegment: "उपयोगकर्ता प्रबंधन बनाएं",
        reqFirstName: "पहला नाम आवश्यक है",
        reqMiddleName: "मध्य नाम आवश्यक है",
        reqLastName: "अंतिम नाम आवश्यक है",
        reqloginID: "लॉगिन नाम आवश्यक है",
        reqPassword: "पासवर्ड की आवश्यकता है",
        reqMobileNumber: "मोबाइल नंबर आवश्यक है",
        reqEmailID: "ईमेल आईडी आवश्यक है",
        reqDateofBirth: "जन्म तिथि आवश्यक है",
        reqGender: "लिंग आवश्यक है",
        reqUserType: "उपयोगकर्ता प्रकार आवश्यक है",
        reqRole: "भूमिका आवश्यक है",
        EnterFirstName: "प्रथम नाम दर्ज करें",
        EnterMiddleName: "मध्य नाम दर्ज करें",
        EnterLastName: "अंतिम नाम दर्ज करो",
        EnterLoginName: "लॉगिन नाम दर्ज करें",
        EnterPassword: "पास वर्ड दर्ज करें",
        EnterUserCode: "उपयोगकर्ता कोड दर्ज करें",
        EnterMobileNo: "मोबाइल नंबर दर्ज करें",
        EnterEmailId: "ईमेल-आईडी दर्ज करें",
        EnterDateOfBirth: "जन्म तारीख दर्ज करें",
        EditUserManegment: "उपयोगकर्ता प्रबंधन संपादित करें",
        UserTypeMaster: "उपयोगकर्ता प्रकार मास्टर",
        EnterUserType: "उपयोगकर्ता प्रकार दर्ज करें",
        UserType: "उपयोगकर्ता का प्रकार",
        InvalidUserType: "अमान्य उपयोक्ता प्रकार",
        SelectWard: "वार्ड का चयन करें",
        reqAreaName: "विज्ञापन क्षेत्र आवश्यक है",
        reqNoOfSites: "साइटों की संख्या आवश्यक है",
        reqImg: "विज्ञापन छवि आवश्यक है",
        reqAdvertisementTypeID: "आवश्यक विज्ञापन प्रकार का चयन करें",
        reqMaxLength: "अधिकतम लंबाई आवश्यक है",
        reqMaxWidth: "अधिकतम चौड़ाई आवश्यक है",
        reqMaxHeight: "अधिकतम ऊंचाई आवश्यक है",
        reqRatePerSqMtr: "प्रति वर्ग मीटर आवश्यक है",
        reqPremium: "प्रीमियम राशि आवश्यक है",
        enterRoleName: "भूमिका का नाम दर्ज करें",
        reqEnterNotice: "सूचना  दर्ज करना आवश्यक है",
        reqEnterNoticeLink: "सूचना  दर्ज करें लिंक आवश्यक है",
        reqEnterDescription: "विवरण दर्ज करना आवश्यक है",
        rowsperpage: "प्रति पृष्ठ पंक्तियाँ:",
        reqcountryName: "देश का नाम आवश्यक है",
        reqRoleName: "भूमिका का नाम आवश्यक है",
        reqstateName: "राज्य का नाम आवश्यक है",
        reqdistrictName: "ज़िला का नाम आवश्यक है",
        RegisterAgency: "रजिस्टर एजेंसी / विक्रेता",
        RenewRegisterAgency: "नवीनीकरण रजिस्टर एजेंसी/विक्रेता",
        ApplyDate: "आवेदन की तिथि",
        NameOfAgency: "एजेंसी का नाम",
        ContactNo: "संपर्क नंबर",
        Address: "पता",
        PANNo: "पैन नंबर",
        AadhaarNo: "आधार नंबर",
        GSTNo: "जीएसटी नंबर",
        ApplicationFee: "आवेदन शुल्क",
        SelectCompanyCategory: "कंपनी श्रेणी चुनें",
        reqAadharNumber: "आधार नंबर आवश्यक है",
        reqBalanceSheet: "बैलेंस शीट आवश्यक है ",
        reqAddress: "पता आवश्यक है",
        reqState: "राज्य आवश्यक है",
        reqEmail: "ईमेल आवश्यक है",
        reqDistrict: "जिला आवश्यक है",
        reqCompanyCategory: "कंपनी श्रेणी आवश्यक है",
        reqPaymentMode: "भुगतान मोड आवश्यक है",
        reqTransactionNumber: "लेनदेन संख्या आवश्यक है",
        DateOfApply: "आवेदन करने की तिथि",
        EnterRegistrationNo: "पंजीकरण संख्या दर्ज करें",
        EnterName: "नाम दर्ज करें",
        EnterContactNo: "संपर्क नंबर दर्ज करें",
        EnterEmailID: "ईमेल आईडी दर्ज करें",
        EnterPANNo: "पैन नंबर दर्ज करें",
        EmailSystem: "ईमेल प्रणाली",
        EnterAadharNo: "आधार नंबर दर्ज करें",
        EnterAddress: "पता दर्ज करें",
        EnterApplicationFees: "आवेदन शुल्क दर्ज करें",
        EnterRegistrationFees: "पंजीकरण शुल्क दर्ज करें",
        reqEnterRegistrationFees: "पंजीकरण शुल्क आवश्यक",
        EnterAgencyName: "एजेंसी का नाम दर्ज करें",
        EnterDINNumber: "डी. आई. एन. संख्या दर्ज करें",
        DINNumber: "डी. आई. एन. नंबर",
        EmailID: "ईमेल आईडी",
        SangamArticle: "कंपनी के समय ज्ञापन तथा संगठन अनुछेद",
        AuthorityExpAdvert:
          "पिछले 3 वर्षों के विज्ञापन व्यवसाय में अभिकरण/फॉर्म का अनुभव",
        Yes: "हाँ",
        No: "नहीं",

        Preview: "पूर्व दर्शन",
        Attach: "संलग्न करना:",

        AttachAadhaarDocument: "आधार दस्तावेज़ संलग्न करें",
        UploadPANDocument: "पैन दस्तावेज़ अपलोड करें",
        OtherDocument: "अन्य दस्तावेज़",
        CreateAgency: "एजेंसी/विक्रेता बनाएं",
        RenewCreateAgency: "नवीनीकरण एजेंसी/विक्रेता",
        EditRenewAgecy: "पंजीकरण एजेंसी/विक्रेता संपादित करें",
        Back: "पीछे",
        Submit: "जमा करना",
        Next: "अगला",
        BasicDetails: "बुनियादी विवरण",
        AgencyDetails: "एजेंसी विवरण",
        TermsAndConditions: "नियम और शर्तें",
        DocUpload: "दस्तावेज़ अपलोड करें",

        EditAgency: "संपादन एजेंसी/विक्रेता",
        DefaultFinancialYear: "डिफ़ॉल्ट वित्तीय वर्ष",
        DayWise: "दिन के अनुसार",
        MonthWise: "माह के अनुसार",
        YearWise: "वर्ष के अनुसार",
        rate: "दर",
        IsRateFixed: "दर तय है",
        EnterRateType: "दर प्रकार दर्ज करें",
        RateType: "दर प्रकार",

        reqName: "नाम आवश्यक है",
        reqAadhaar: "आधार नंबर आवश्यक है",
        reqAadhaarexactly: "आधार नंबर बिल्कुल 12 अंकों का होना चाहिए",
        reqMobile: "मोबाइल नंबर आवश्यक है",
        reqRegistrationPayment: "पंजीकरण भुगतान मोड आवश्यक है",
        reqPanNumber: "पैन नंबर आवश्यक है",
        reqGSTINnumber: "जीएसटीआईएन नंबर आवश्यक है",
        reqApplyDate: "आवेदन तिथि आवश्यक है",
        reqAlert:
          "कृपया तालिका में जोड़ने से पहले सभी आवश्यक फ़ील्ड (एजेंसी का नाम, डीआईएन नंबर, ईमेल आईडी और मोबाइल नंबर) भरें।",
        validMobile: "वैध-मोबाइल है",
        InvalidMobile: "अमान्य मोबाइल नंबर फॉर्मेट है",
        validEmail: "वैध-ईमेल है",
        InvalidEmail: "अमान्य ईमेल प्रारूप है",

        Designationmastermain: "पद मास्टर",
        editDesignation: "पद मास्टर संपादित करें",
        AddDesignation: "पद मास्टर बनाएं",

        Name: "नाम",
        reqFirst: "पहला नाम आवश्यक है",
        reqLast: "अंतिम नाम आवश्यक है",
        reqLogin: "लॉगिन आईडी आवश्यक है",
        reqDate: "जन्म तिथि आवश्यक है",
        reqUser: "उपयोगकर्ता प्रकार आवश्यक है",

        ReplacementInfo: "प्रतिस्थापन जानकारी",

        deptMaster: "विभाग मास्टर",
        deptName: "विभाग का नाम",
        deptCode: "विभाग कोड",
        createdeptmaster: "विभाग मास्टर बनाएँ",
        editdeptmaster: "विभाग मास्टर संपादित करें",
        enterdeptName: "विभाग का नाम दर्ज करें",
        enterdeptCode: "विभाग कोड दर्ज करें",
        reqdept_name: "विभाग का नाम आवश्यक",
        desName: "पदनाम मास्टर",
        createddesigMAster: "पदनाम बनाएं मास्टर",
        reqdesignname: "पदनाम नाम आवश्यक है",
        enterDesName: "पदनाम नाम दर्ज करें",
        entershortCode: "पदनाम कोड दर्ज करें",
        selectDet: "विभाग का चयन करें",
        reqdept_id: "आवश्यक विभाग का चयन करें",
        editdesMaster: "पदनाम संपादित करें मास्टर",
        AttachImg: "लेनदेन रसीद संलग्न करें",
        SelectDepartment: "विभाग का चयन करें",
        SelectDesignation: "पदनाम का चयन करें",
        CreatePetitionerPersonalInformation:
          "याचिकाकर्ता की व्यक्तिगत जानकारी बनाएँ",
        EnterCouncelForRespondent: "प्रतिवादी के लिए परामर्श दर्ज करें",
        EnterRespondentContact: "प्रतिवादी संपर्क दर्ज करें",
        EnterRespondentEmail: "प्रतिवादी ईमेल दर्ज करें",
        SelectCaseNo: "केस नंबर चुनें",
        SelectCourtName: "न्यायालय का नाम चुनें",
        SelectCourtType: "न्यायालय प्रकार का चयन करें",
        EnterRespodingCounselName:
          "प्रत्युत्तर देने वाले वकील का नाम दर्ज करें",
        BaseYear: "आधार वर्ष",
        baseYearName: "आधार वर्ष का नाम",
        DefaultbaseYear: "डिफ़ॉल्ट आधार वर्ष",
        ReqEnterbaseYearName: "आवश्यक आधार वर्ष दर्ज करें",
        CreateBaseYearMaster: "आधार वर्ष मास्टर बनाएं ",
        EditBaseYearMaster: "आधार वर्ष मास्टर संपादित करें",
        SelectBaseYear: "आधार वर्ष चुनें",
        effectiveDate: "प्रभावी तिथि",
        EntryDate: "प्रवेश तिथि",
        SqFt: "वर्ग फुट",
        ReqDate: "दिनांक आवश्यक है",
        ReqFree: "निःशुल्क आवश्यक है",
        ReqRate: "दर आवश्यक है",
        TransactionImage: "रसीद संलग्न करें",
        reqRateType: "दर प्रकार आवश्यक है",
        FileClass: "फ़ाइल वर्ग",
        classDescription: "वर्ग विवरण",
        shortName: "संक्षिप्त नाम",
        weedingOutAuthority: "प्राधिकरण को हटाना",
        CreateclassDescription: "कक्षा विवरण बनाएँ ",
        EnterShortName: "संक्षिप्त नाम दर्ज करें",
        EnterClassDescription: "कक्षा विवरण दर्ज करें",
        EnterWeedingOutAuthority: "प्राधिकरण को बाहर निकालने में प्रवेश करें",
        CreateFileClass: "फ़ाइल वर्ग बनाएँ",
        EditFileClass: "फ़ाइल वर्ग संपादित करें",
        FileGroupName: "फ़ाइल समूह का नाम",
        EnterFileGroupName: "फ़ाइल समूह का नाम दर्ज करें",
        FileGroup: "फ़ाइल समूह",
        FileSubject: "फ़ाइल विषय",
        EnterFileSubjectName: "फ़ाइल विषय नाम दर्ज करें ",
        FileSubjectName: "फ़ाइल का विषय नाम",
        // ShortName: "संक्षिप्त नाम",
        ReplacementInfo: "प्रतिस्थापन जानकारी",
        Empname: "कर्मचारी का नाम",
        Employee: "कर्मचारी मास्टर",
        Code: "कोड",
        Mobileno: "मोबाइल नंबर",
        Sim: "सिम",
        Device: "डिवाइस",
        Both: "दोनों",
        FileType: "फ़ाइल प्रकार",
        EnterFileTypeName: "फ़ाइल प्रकार का नाम दर्ज करें",
        FileTypeName: "फ़ाइल प्रकार का नाम",
        SelectFileGroup: "फ़ाइल समूह का चयन करें",
        SelectFileCategory: "फ़ाइल श्रेणी का चयन करें",
        SelectFileType: "फ़ाइल प्रकार का चयन करें",
        SelectFileNo: "फ़ाइल संख्या का चयन करें",
        SelectFileClass: "फ़ाइल वर्ग का चयन करें",
        SelectFileSubject: "फ़ाइल विषय का चयन करें",
        ReceiptStatus: "रसीद की स्थिति",
        RecName: "रसीद का नाम",
        EnterRecName: "रसीद का नाम दर्ज करें",
        ReceiptType: "रसीद का प्रकार",
        ReceiptName: "रसीद का नाम",
        EnterReceiptName: "रसीद का नाम दर्ज करें",
        RecStatus: " रसीद की स्थिति",
        EnterRecStatus: "रसीद की स्थिति दर्ज करें",
        reqRecStatus: "रसीद की स्थिति आवश्यक है ",
        Location: "स्थान",
        LocationName: "स्थान का नाम",
        EnterLocationName: "स्थान का नाम दर्ज करें",
        LocationShortName: " स्थान संक्षिप्त नाम",
        EnterLocationShortName: "स्थान संक्षिप्त नाम दर्ज करें",
        senderID: "प्रेषक आईडी",
        receiverID: "रिसीवर आईडी",
        currentLocation: "वर्तमान स्थान",
        EnterSignatureUpload: "हस्ताक्षर संलग्न करें",
        EnterLocationObject: "स्थान ऑब्जेक्ट दर्ज करें",
        EnterAbbreviation: "संक्षिप्त नाम दर्ज करें",
        Abbreviation: "लघु रूप",
        LocationObject: "स्थान वस्तु",
        reqLocationObject: "स्थान ऑब्जेक्ट की आवश्यकता है ",
        reqFileGroupName: "फ़ाइल समूह नाम की आवश्यकता है",
        reqFileSubjectName: "फ़ाइल विषय नाम की आवश्यकता है",
        reqFileTypeName: "फ़ाइल प्रकार नाम आवश्यक है",
        reqReceiptName: "रसीद नाम की आवश्यकता है",
        EnterDocUpload: "दस्तावेज़ संलग्न करें",
        EnterDocSubType: "दस्तावेज़ विषय प्रकार",
        EnterSubDocAbbreviation: "दस्तावेज़ विषय संक्षिप्त नाम",
        SelectDoctype: "दस्तावेज़ प्रकार चुनें",
        SelectFileName: "फ़ाइल नाम चुनें",
        SelectSubject: "विषय चुनें",
        SelectDivision: "प्रभाग का चयन करें",
        EnterCountryShortName: "देश का संक्षिप्त नाम दर्ज करें",
        EnterStateShortName: "राज्य का संक्षिप्त नाम दर्ज करें",
        EnterdisplayNo: "डिस्प्ले नंबर दर्ज करें",
        SelectDocType: "दस्तावेज़ प्रकार का चयन करें",
        enterDesCode: "पदनाम कोड दर्ज करें",
        DesignationName: "पदनाम का नाम",
        DesignationCode: "पदनाम कोड",
        DocType: "दस्तावेज़ का प्रकार",
        DocSubType: "दस्तावेज़ उप प्रकार",
        CreateDocType: "दस्तावेज़ प्रकार बनाएँ",
        EditDocType: "दस्तावेज़ प्रकार संपादित करें",
        EnterDocType: "दस्तावेज़ प्रकार दर्ज करें",
        EntryDate: "प्रवेश की तारीख",
        EnterDocName: "दस्तावेज़ का नाम दर्ज करें",
        DocSubject: "दस्तावेज़ विषय",
        Subject: "विषय",
        DocSubSubject: "दस्तावेज़ उप विषय",
        SubSubject: "उप विषय",
        FileNo: "फ़ाइल संख्या",
        Synopsis: "रूपरेखा",
        FileDef: "फ़ाइल परिभाषा",
        DocumentEntry: "दस्तावेज़ प्रविष्टि",
        DocumentEntryAdd: "दस्तावेज़ प्रविष्टि जोड़ें",
        reqFileNo: "फ़ाइल नंबर की आवश्यकता है",
        EnterFileNo: "फ़ाइल संख्या दर्ज करें",
        EnterSynopsis: "सारांश दर्ज करें",
        EnterPartNo: "भाग संख्या दर्ज करें",
        EnterPeriodFileUpto: "तक पीरियड फाइल दर्ज करें",
        EnterSubject: "विषय दर्ज करें",
        EnterFileDef: " फ़ाइल परिभाषा दर्ज करें",
        EnterComplete: "पूर्ण दर्ज करें",
        EnterAuthenticatePerson: "प्रमाणित व्यक्ति दर्ज करें",
        EnterFileDate: "फ़ाइल दिनांक दर्ज करें",
        SelectFile: "फ़ाइल का चयन करें",
        SelectSubject: "विषय का चयन करें",
        SelectDivision: "डिवीजन का चयन करें",
        EnterPeriodDate: "अवधि तिथि दर्ज करें",
        AttachedFile: "अनुलग्न फ़ाइल",
        EnterFileName: "फ़ाइल नाम दर्ज करें",
        PeriodDate: "अवधि की तारीख",
        Keywords: "कीवर्ड",
        FileName: "फ़ाइल का नाम",
        PdfFile: "पीडीएफ",
        DocumentEntryEdit: "दस्तावेज़ प्रविष्टि संपादित करें",
        EnterKeyword: "कीवर्ड दर्ज करें",
        PdfName: "पीडीएफ नाम",
        DocFiles: "दस्तावेज़ फ़ाइलें",
        SelectDoc: "दस्तावेज़ का चयन करें",
        SelectLocation: "स्थान का चयन करें",
        reqPdfName: "पीडीएफ नाम की आवश्यकता है",
        CreateDocFiles: "दस्तावेज़ फ़ाइलें बनाएँ",
        EditDocFiles: "दस्तावेज़ फ़ाइलें संपादित करें",
        EnterPdfName: "पीडीएफ नाम दर्ज करें",
        EnterKeywords: "कीवर्ड दर्ज करें",
        EnterSubFtype: "उप फ़ाइल प्रकार दर्ज करें",
        EnterPdfDate: "पीडीएफ तिथि दर्ज करें",
        DocPages: "दस्तावेज़ पृष्ठ",
        Comments: "टिप्पणियाँ",
        PhysicalSerialNo: "भौतिक क्रम संख्या",
        PhysicalIndex: "भौतिक सूचकांक",
        CreateDocPages: "दस्तावेज़ पेज बनाएं",
        EditDocPages: "दस्तावेज़ पृष्ठ संपादित करें",
        PageNoFrom: "पृष्ठ संख्या से",
        PageNoUpto: "पृष्ठ क्रमांक तक",
        EnterComments: "टिप्पणियाँ दर्ज करें",
        EnterPhysicalSerialNo: "भौतिक सीरियल नंबर दर्ज करें",
        EnterPhysicalIndex: "भौतिक अनुक्रमणिका दर्ज करें",
        SelectField: "फ़ील्ड का चयन करें",
        DocViewer: "दस्तावेज़ व्यूअर",
        SubFileType: "उप फ़ाइल प्रकार",
        ViewPdf: "पीडीएफ देखें",
        View: "देखना",
        NoRecordAvailable: "कोई रिकॉर्ड उपलब्ध नहीं है",
        NoPdfAvailable: "कोई पीडीएफ उपलब्ध नहीं है",
        AddComment: "टिप्पणी जोडा",
        PageNoFrom: "पृष्ठ संख्या से",
        PageNoTo: "पृष्ठ संख्या को",
        RelatedOficer: "संबंधित अधिकारी",
        AddRow: "पंक्ति जोड़ें",
        Index: "सूचकांक!",
        SelectDevision: "प्रभाग का चयन करें",
        SelectFileStatus: "फ़ाइल स्थिति का चयन करें",
        DocumentIndexing: "दस्तावेज़ अनुक्रमण",
        Filter: "फ़िल्टर ",
        Print: "प्रिंट",
        PeriodFrom: "से अवधि",
        PeriodTo: "अवधि से",
        Search: "ढूँढ",
        Clear: "स्पष्ट",
        ViewIndexPdf: "इंडेक्स पीडीएफ देखें",
        ViewFullPdf: "पूरा पीडीएफ देखें",
        FileDefinition: "फ़ाइल परिभाषा",
        SearchKeywords: "खोज कीवर्ड",
        DateFrom: "तारीख से",
        DateTo: "करने के लिए तारीख",
        Complete: "पूरा",
        SplitPdfToJump: "जम्प के लिए पीडीएफ विभाजित करें",
        SplitPage: "विभाजित पृष्ठ",
        PdfFileName: "पीडीएफ फाइल का नाम",
        PageFrom: "पृष्ठ से",
        PageTo: "पृष्ठ तक",
        ViewFile: "फ़ाइल देखें",
        AddPdf: "पीडीएफ जोड़ें",
        DocUpload: "दस्तावेज़ अपलोड",
        EnterRemark: "टिप्पणी दर्ज करें",
        EnterValue: "मान दर्ज करें",
        FileSaved: "फ़ाइल सहेजी गई",
        EnterMainPdf: "मुख्य पीडीएफ दर्ज करें",
        EnterPdf: "पीडीएफ दर्ज करें",
        PdfMearge: "पीडीएफ मर्ज",
        SplitMainFile: "मुख्य फ़ाइल विभाजित करें",
        ForRename: "नाम बदलने के लिए",
        ForShiftCategory: "शिफ्ट श्रेणी के लिए",
        UpdatePdf: "पीडीएफ अपडेट करें",
        PdfCounter: "पीडीएफ काउंटर",
        EnterFolderPath: "फ़ोल्डर पथ दर्ज करें",
        Count: "गिनना",
        EmployeeEntry: "कर्मचारी प्रवेश",
        EmployeeName: "कर्मचारी का नाम",
        Login: "लॉगिन",
        Password: "पासवर्ड",
        Edit: "संपादित करें",
        delete: "मिटाना",
        Export: "निर्यात ",
        Release: "जारी ",
        Post: "पोस्ट ",
        SelectEmployeeName: "कर्मचारी का नाम चुनें",
        ParentName: "जनक नाम",
        EmployeeMaster: "कर्मचारी मास्टर",
        EmpName: "कर्मचारी का नाम",
        EmpCode: "कर्मचारी कोड",
        EmpStatus: "कर्मचारी की स्थिति",
        SelectState: "राज्य का चयन करें",
        SelectCountry: "देश का चयन करें",
        SelectDistrict: "जिले का चयन करें",
        reqEmpName: "कर्मचारी का नाम आवश्यक है",
        reqEmpCode: "कर्मचारी कोड की आवश्यकता है",
        reqFatherName: "पिता का नाम आवश्यक है",
        reqMobNo: "मोबाइल नंबर की आवश्यकता है",
        reqPanNo: "पैन नंबर की आवश्यकता है",
        reqJoiningDate: "ज्वाइनिंग डेट आवश्यक है",
        reqDesignation: "पदनाम की आवश्यकता है",
        reqDepartment: "विभाग की आवश्यकता है",
        reqPerAddress: "स्थायी पते की आवश्यकता है",
        reqPinCode: "पिन कोड की आवश्यकता है",
        reqAdharNo: "आधार नंबर की आवश्यकता है",
        reqEmail: "ईमेल की आवश्यकता है",
        reqEmpdob: "कर्मचारी जन्मतिथि आवश्यक है",

        CreateEmployeeReg: "कर्मचारी पंजीकरण बनाएँ",
        EditEmployeeReg: "कर्मचारी पंजीकरण संपादित करें",

        EnterEmpName: "कर्मचारी का नाम दर्ज करें",
        EnterEmpCode: "कर्मचारी कोड दर्ज करें",
        EnterFatherName: "पिता का नाम दर्ज करें",
        EnterSpauseName: "स्पाज़ नाम दर्ज करें",
        EnterMotherName: "माता का नाम दर्ज करें",
        EnterMobileNumber: "मोबाइल नंबर दर्ज करें",
        EnterEmail: "ईमेल दर्ज करें",
        EnterPanNo: "पैन नंबर दर्ज करें",
        EnterAdharNo: "आधार नंबर दर्ज करें",
        EnterDOB: "जन्म तिथि दर्ज करें",
        EnterJoiningDate: "ज्वाइनिंग डेट दर्ज करें",
        EnterRetirementDate: "सेवानिवृत्ति की तिथि दर्ज करें",
        EnterLocalAddress: "स्थानीय पता दर्ज करें",
        EnterPerAddress: "स्थायी पता दर्ज करें",
        EnterPinCode: "पिन कोड दर्ज करें",
        AttachedImage: "संलग्न छवि",
        DocManagerReport: "दस्तावेज़ प्रबंधक रिपोर्ट",
        SelectSubSubject: " उप विषय का चयन करें",
        SubSubjectName: "उप विषय का नाम",
        DivisionName: "डिवीजन का नाम",
        Remark: "टिप्‍पणी करना",
        SessionYear: "सत्र वर्ष",
        InActive: "निष्क्रिय",
        Active: "सक्रिय",
        TotalDoc: "कुल दस्तावेज़",
        TotalType: "कुल प्रकार",
        TotalIndexFile: "कुल अनुक्रमणिका फ़ाइल",
        TotalSplitFile: "कुल विभाजित फ़ाइल",
        Zone: "क्षेत्र",
        LineChart: "लाइन चार्ट",
        Department: "विभाग",
        AcademicDepartment: "शैक्षणिक विभाग",
        DocumentManagementSystem: "दस्तावेज़ प्रबंधन प्रणाली",
        PartNo: "भाग संख्या",
        PeriodFileNo: "अवधि फ़ाइल संख्या",
        AuthonticatedPerson: "प्रामाणिक व्यक्ति",
        FileDate: "फ़ाइल दिनांक",
        SubjectId: "विषय आईडी ",
        ToDate: "तारिख तक",
        MergeToIndexFile: "इंडेक्स  फ़ाइल में मर्ज करें",
        MergeToOriginalFile: "मूल फ़ाइल में मर्ज करें",
        DOB: "जन्म तिथि",
        Comment: "टिप्पणी",
        enteritemType: "वस्तु प्रकार दर्ज करें",
        ItemMaster: "वस्तु मास्टर",
        EnteritemName: "वस्तु नाम दर्ज करें",
        EnteritemCode: "वस्तु कोड दर्ज करें",
        EnteritemTypeId: "आइटम पहचान दर्ज करें",
        enterempId: "कर्मचारी पहचान दर्ज करें",
        entertaxId: "कर पहचान दर्ज करें",
        itemCategory: "वस्तु श्रेणी",

        enterpurchaseYear: "खरीद वर्ष दर्ज करें",
        unitId: "इकाई आईडी",
        EnterunitId: "इकाई आईडी दर्ज करें",
        entermodelNo: "प्रतिरूप संख्या दर्ज करें",
        EnterserialNo: "क्रमानुसार दर्ज करें",
        itemType: "वस्तु का प्रकार",
        itemTypecode: "वस्तु प्रकारकोड",
        EnteritemTypecode: "एंटर वस्तु प्रकारकोड",
        taxName: "करनाम",
        taxPercentage: "कर प्रतिशत",
        EffectiveDate: "प्रभावी तिथि",
        TaxMaster: "टैक्समास्टर",
        EntertaxName: " करनाम दर्ज करें",
        EntertaxPercentage: "कर प्रतिशत दर्ज करें",
        EntereffectiveDate: "प्रभावी तिथि दर्ज करें",
        itemName: "वस्तु नाम",
        itemCode: "वस्तु कोड",
        purchaseYear: "खरीदवर्ष",
        modelNo: "प्रतिरूप संख्या",
        vehicleNo: "वाहन नं",
        hsnCode: "एचएसएन कोड",
        itemWeight: "वस्तु का वजन",
        EntervehicleNo: " वाहन नं दर्ज करें",
        EnterchesisNo: " शतरंज नं दर्ज करें",
        EnterhsnCode: " एचएसएन कोड दर्ज करें",
        EnteritemWeight: "वस्तु  का वजन दर्ज करें",
        enterdepreciationRate: "मूल्यह्रास दर दर्ज करें",
        itemCategoryAbbre: "वस्तुश्रेणीएब्रे",
        parentId: "माता पिता की पहचान",
        taxId: "टैक्स आईडी",
        EnteritemCategory: "वस्तु श्रेणी दर्ज करें",
        EnteritemCategoryAbbre: "वस्तुश्रेणीएब्रे दर्ज करें",
        EntertaxId: "टैक्स आईडी दर्ज करें",
        EntryNo: "प्रविष्टि क्रमांक",
        batchNo: "बैचवाइज",
        itemId: "वस्तुआईडी",
        unitID: "यूनिटआईडी",
        rate: "दर",
        inQty: "मात्रा",
        outQty: "मात्रा से बाहर",
        voucherId: "वाउचरआईडी",
        stockBinId: "स्टॉकबिनआईडी",
        voucherType: "वाउचर प्रकार",
        voucherDate: "वाउचर दिनांक",
        expiryDate: "समाप्ति तिथि",
        companyId: "कंपनी आईडी",
        gstRate: "जीएसटी दर",
        cgst: "सी.जी.एस.टी",
        sgst: "एस.जी.एस.टी",
        igst: "आई.जी.एस.टी",
        gstid: "जी.एस.टी.आईडी",
        cgstid: "सी.जी.एस.टी.आईडी",
        sgstid: "एस.जी.एस.टी आईडी",
        igstid: "आई.जी.एस.टी आईडी",
        StockLedger: "स्टॉकलेजर",
        EnterentryNo: "एंट्री नं दर्ज करें",
        EnterbatchNo: "बैच नं  दर्ज करें",
        EnteritemId: "वस्तु वस्तु दर्ज करें",
        EnterunitID: "यूनिट आईडी दर्ज करें",
        Enterrate: "दर दर्ज करें",
        EnterinQty: "मात्रा दर्ज करें",
        EnteroutQty: "मात्रा से बाहर दर्ज करें",
        EntervoucherId: "वाउचर आईडी  दर्ज करें",
        EntervoucherType: "वाउचर प्रकार दर्ज करें",
        EntervoucherDate: "वाउचर दिनांक  दर्ज करें",
        EnterexpiryDate: "समाप्ति तिथि दर्ज करें",
        EntergstRate: "जीएसटी दर दर्ज करें",
        Entersgst: "एस.जी.एस.टी दर्ज करें",
        Entercgst: "सी.जी.एस.टी दर्ज करें",
        Enterigst: "आई.जी.एस.टी दर्ज करें",
        entergstid: "जी.एस.टी.आईडी दर्ज करें",
        Entersgstid: "एस.जी.एस.टी आईडी दर्ज करें",
        Enterigstid: "आई.जी.एस.टी आईडी  दर्ज करें",
        unitName: "इकाई का नाम",
        unitShortname: "इकाईसंक्षिप्तनाम",
        UnitMaster: "यूनिटमास्टर",
        enterunitName: "इकाई का नाम दर्ज करें",
        enterunitShortname: "इकाईसंक्षिप्तनाम दर्ज करें",

        JurisdictionMaster: "क्षेत्राधिकार मास्टर",
        EnterJurisdictionName: "क्षेत्राधिकार का नाम दर्ज करें",
        SelectNode: "नोड का चयन करें",
        NodePermission: "नोड अनुमति",
        SelectUser: "उपयोगकर्ता का चयन करें",
        PollMaster: "पोल मास्टर",
        CreatePollMaster: "पोल मास्टर बनाएं",
        poleName: "ध्रुव नाम",
        SelectPollType: "पोल प्रकार चुनें",
        Hight: "ऊंचाई",
        wight: "वज़न",
        Thickness: "मोटाई",
        poleColor: "ध्रुव रंग",
        underGroundPoleHight: "जमीन के नीचे पोल की ऊंचाई",
        numOfLightAttach: "लाइट संलग्न की संख्या",
        currentStatus: "वर्तमान स्थिति",
        poleImg: "ध्रुव छवि",
        EditPollMaster: "पोल मास्टर संपादित करें",
        PoleType: "पोल प्रकार",
        PoleTypeName: "पोल प्रकार का नाम",
        //Inventory Module
        CreateIndent: "इंडेंट बनाएं",
        EditIndent: "इंडेंट संपादित करें",
        estimateNo: "अनुमान संख्या दर्ज करें",
        emp_name: "कर्मचारी का नाम दर्ज करें",
        indentDate: "इंडेंट दिनांक चुनें",

        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        Dashboard: "Dashboard",
        Tracking: "Tracking",
        GeofacingCreate: "Geofencing Create",
        KudagharLocation: "Kudaghar Location",
        VehicleHistory: "Vehicle History",
        VehicleTravelled: "Vehicle Travelled",
        VehicleNotMoved: "Vehicle Not Moved",
        VehicleDetailsSummery: "Vehicle Details Summary",
        ProbableWireTempering: "Probable Wire Tempering",
        FuelConsumption: "Fuel Consumption",
        FuelConspWithoughtOpening: "Fuel Consumption Without Opening",
        FuelConspWithOpening: "Fuel Consumption With Opening",
        VehicleTrack: "Vehicle Track",
        Period: "Period",
        VehicleType: "Vehicle Type",
        VehicleNo: "Vehicle Number",
        Latitute: "Latitute",
        Longitude: "Longitude",
        Radius: "Radius",
        FenceName: "Fence Name",
        TrackingDate: "Tracking Date",
        Speed: "Speed",
        HelpDesk: "Help Desk",
        HelpCreation: "Help Creation",
        PageTitle: "Page Title",

        // himanshu
        SelectEmployeeName: "कर्मचारी का नाम चुनें",
        ParentName: "जनक नाम",
        EmployeeMaster: "कर्मचारी मास्टर",
        EmpName: "कर्मचारी का नाम",
        EmpCode: "कर्मचारी कोड",
        EmpStatus: "कर्मचारी की स्थिति",
        SelectState: "राज्य का चयन करें",
        SelectCountry: "देश का चयन करें",
        SelectDistrict: "जिले का चयन करें",
        reqEmpName: "कर्मचारी का नाम आवश्यक है",
        reqEmpCode: "कर्मचारी कोड की आवश्यकता है",
        reqFatherName: "पिता का नाम आवश्यक है",
        reqMobNo: "मोबाइल नंबर की आवश्यकता है",
        reqPanNo: "पैन नंबर की आवश्यकता है",
        reqJoiningDate: "ज्वाइनिंग डेट आवश्यक है",
        reqDesignation: "पदनाम की आवश्यकता है",
        reqDepartment: "विभाग की आवश्यकता है",
        reqPerAddress: "स्थायी पते की आवश्यकता है",
        reqPinCode: "पिन कोड की आवश्यकता है",
        reqAdharNo: "आधार नंबर की आवश्यकता है",
        reqEmail: "ईमेल की आवश्यकता है",
        reqEmpdob: "कर्मचारी जन्मतिथि आवश्यक है",
        CreateEmployeeReg: "कर्मचारी मास्टर पंजीकरण बनाएँ",
        EditEmployeeReg: "कर्मचारी मास्टर पंजीकरण संपादित करें",
        EnterEmpName: "कर्मचारी का नाम दर्ज करें",
        EnterEmpCode: "कर्मचारी कोड दर्ज करें",
        EnterFatherName: "पिता का नाम दर्ज करें",
        EnterSpauseName: "स्पाज़ नाम दर्ज करें",
        EnterMotherName: "माता का नाम दर्ज करें",
        EnterMobileNumber: "मोबाइल नंबर दर्ज करें",
        EnterEmail: "ईमेल दर्ज करें",
        EnterPanNo: "पैन नंबर दर्ज करें",
        EnterAdharNo: "आधार नंबर दर्ज करें",
        EnterDOB: "जन्म तिथि दर्ज करें",
        EnterJoiningDate: "ज्वाइनिंग डेट दर्ज करें",
        EnterRetirementDate: "सेवानिवृत्ति की तिथि दर्ज करें",
        EnterLocalAddress: "स्थानीय पता दर्ज करें",
        EnterPerAddress: "स्थायी पता दर्ज करें",
        EnterPinCode: "पिन कोड दर्ज करें",
        AttachedImage: "संलग्न छवि",
        DocManagerReport: "दस्तावेज़ प्रबंधक रिपोर्ट",
        SelectSubSubject: " उप विषय का चयन करें",
        SubSubjectName: "उप विषय का नाम",
        DivisionName: "डिवीजन का नाम",
        Remark: "टिप्‍पणी करना",
        SessionYear: "सत्र वर्ष",
        InActive: "निष्क्रिय",
        Active: "सक्रिय",
        TotalDoc: "कुल दस्तावेज़",
        TotalType: "कुल प्रकार",
        TotalIndexFile: "कुल अनुक्रमणिका फ़ाइल",
        TotalSplitFile: "कुल विभाजित फ़ाइल",
        //email module
        AddEmailSystem: "ईमेल सिस्टम बनाएं",
        Date: "तारीख",
        Type: "प्रकार",
        Time: "समय",
        EmailSystem: "ईमेल प्रणाली",
        AddEmailsystem: "ईमेल प्रणाली बनाएं",
        Editemailsystem: "ईमेल प्रणाली संपादित करें",
        Emaildescription: "ईमेल विवरण",
        Smsgroup: "एसएमएस समूह",
        Emailgroup: "ईमेल समूह",
        Statusactive: "स्थिति का चयन करें",
        EmailSetting: "ईमेल सेटिंग",
        Emailtype: "प्रकार",
        Emailcampaigname: "अभियान नाम दर्ज करें",
        Emailfromdate: "से तारीख",
        Emailtodate: "तक तारीख",
        Emailcampgiandate: "अभियान तारीख",
        Template: "टेम्पलेट  का चयन करें",
        Totime: "तक समय",
        execute: "सहेजें और निष्पादित करें",
        Emaileventsetting: "ईमेल इवेंट  सेटिंग",
        Emaileventtype: "इवेंट  प्रकार का चयन करें",
        Emaileventname: "इवेंट  नाम दर्ज करें",
        message: "संदेश दर्ज करें",

        TrackTime: "ट्रैक समय",
        kmPerLitre: "किमी प्रति लीटर",
        Ignition: "इग्निशन",
        Distance: "दूरी",
        FuelConsumed: "ईंधन की खपत",
        Driver: "चालक",
        Duration: "अवधि",
        Polygon: "बहुभुज",
        Running: "चालू",
        Idle: "निष्क्रिय",
        StartTime: "समय शुरू",
        EndTime: "अंत समय",
        BinLocation: "बिन स्थान",

        DistanceKm: "दूरी(किमी)",
        avgSpeed: "औसत रफ़्तार",
        TimeConsuption: "समय की खपत",
        MileageKmLtr: "माइलेज(किमी/लीटर)",
        FuelAlloted: "ईंधन आवंटित",
        TotFuelAllot: "कुल आवंटित ईंधन",
        TotalDays: "कुल दिन",
        DistanceAlloted: "दूरी आवंटित",
        ActualDistance: "वास्तविक दूरी",
        DistanceAlloted: "दूरी आवंटित",
        BalanceDist: "शेष जिला",
        BalanceFuel: "संतुलन ईंधन",
        SelectVehicleNo: "वाहन क्रमांक चुनें",
        SelectVehicleType: "वाहन का प्रकार चुनें",
        reqModelNo: "आवश्यक मॉडल नं",
        EmpNameRequired: "कर्मचारी का नाम आवश्यक है",
        EmpCodeRequired: "कर्मचारी कोड आवश्यक है",
        FatherNameRequired: "पिता का नाम आवश्यक है",
        MobNoRequired: "मोबाइल नंबर आवश्यक है",
        PanNoRequired: "पैन नंबर आवश्यक है",
        AdharNoRequired: "आधार नंबर आवश्यक है",
        DobRequired: "जन्मतिथि आवश्यक है",
        JoiningDateRequired: "जॉइनिंग तिथि आवश्यक है",
        DepartmentRequired: "विभाग आवश्यक है",
        PermanentAddressRequired: "स्थायी पता आवश्यक है",
        Organization: "संगठन",
        AddOrganization: "संगठन जोड़ें",
        EditOrganization: "संगठन संपादित करें",
        correctionDate: "सुधार तिथि",
        PageName: "पेज का नाम",
        Latitude: "अक्षांश",

        reqCountryName: "देश का नाम आवश्यक है",
        reqZoneName: "ज़ोन का नाम आवश्यक है",
        reqdeptName: "विभाग का नाम आवश्यक है",
        reqDLNO: "डीएल नम्बर आवश्यक है",
        PincodeRequired: "पिनकोड आवश्यक है",
      },
      content: {},
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: storedLanguage || "en",
  // lng: 'hi',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
